<template>
  <div v-if="isAdminMyStudio" class="container-area-personale">
    <div class="header">
      <h2 class="title">AREA AMMINISTRATORE</h2>
    </div>
    <br />
    <div class="main-content">
      <div class="flexing">
        <div class="controlli-wrapper">
          <!-- Pulsante per mostrare/nascondere il form -->
          <button
            class="toggle-form-btn"
            :class="{ active: mostraFormRegistrazione }"
            @click="
              mostraFormRegistrazione = !mostraFormRegistrazione;
              mostraFormPrezzi = false;
              mostraModalImpostazioniIA = false;
              mostraModalStrumentiTest = false;
            "
            :title="
              mostraFormRegistrazione
                ? 'Chiudi Registra utenti'
                : 'Registra nuovi utenti'
            "
          >
            <template>
              <i class="fa-solid fa-user-plus"></i>
              Registra utenti
            </template>
          </button>
          <button
            class="toggle-form-btn"
            :class="{ active: mostraFormPrezzi }"
            @click="
              mostraFormPrezzi = !mostraFormPrezzi;
              mostraFormRegistrazione = false;
              mostraModalImpostazioniIA = false;
              mostraModalStrumentiTest = false;
            "
            :title="
              mostraFormPrezzi ? 'Chiudi sezione prezzi' : 'Apri sezione prezzi'
            "
          >
            <template>
              <i class="fa-solid fa-euro-sign"></i>
              Prezzi MyStudio
            </template>
          </button>
          <button
            class="toggle-form-btn"
            :class="{ active: mostraModalImpostazioniIA }"
            @click="openAiSettingsModal"
            title="Gestisci impostazioni IA"
          >
            <i class="fa-solid fa-wand-magic-sparkles"></i>
            Impostazioni IA
          </button>
          <button
            class="toggle-form-btn"
            :class="{ active: mostraModalStrumentiTest }"
            @click="openTestToolsModal"
            title="Configura gli strumenti riservati ai test"
          >
            <i class="fa-solid fa-flask"></i>
            Strumenti test
          </button>
          <button
            class="toggle-form-btn"
            @click="openNewsAdminModal"
            title="Gestisci le Notizie"
          >
            <i class="fa-solid fa-bullhorn"></i>
            Gestisci Notizie
          </button>
          <button
            class="toggle-form-btn"
            @click="goToFileSystem"
            title="Esplora FileSystem"
          >
            <i class="fa-solid fa-folder-tree"></i>
            Gestione File
          </button>
          <button
            class="toggle-form-btn"
            @click="goToDiagnosticaConversioni"
            title="Apri diagnostica estrazioni"
          >
            <i class="fa-solid fa-triangle-exclamation"></i>
            Diagnostica
          </button>

          <div
            v-if="mostraModalImpostazioniIA"
            class="modal-overlayform ai-settings-overlay"
            @click.self="closeAiSettingsModal"
          >
            <div
              class="modal-content-news ai-settings-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="ai-settings-title"
            >
              <button
                class="ai-modal-close"
                type="button"
                aria-label="Chiudi impostazioni IA"
                @click="closeAiSettingsModal"
              >
                <i class="fa-solid fa-xmark"></i>
              </button>

              <header class="ai-settings-header">
                <span class="ai-header-icon">
                  <i class="fa-solid fa-robot"></i>
                </span>
                <div class="ai-header-copy">
                  <p>Configurazione globale</p>
                  <h2 id="ai-settings-title">Estrattori IA</h2>
                </div>
                <span
                  class="ai-status-badge"
                  :class="{
                    active:
                      impostazioniIA.use_datev_new_extractor ||
                      impostazioniIA.use_teamsystem_new_extractor ||
                      impostazioniIA.use_f24_new_extractor,
                  }"
                >
                  {{
                    impostazioniIA.use_datev_new_extractor ||
                    impostazioniIA.use_teamsystem_new_extractor ||
                    impostazioniIA.use_f24_new_extractor
                      ? "IA attiva"
                      : "Classico"
                  }}
                </span>
              </header>

              <div v-if="loadingImpostazioniIA" class="ai-settings-loading">
                <span class="ai-loader"></span>
                Caricamento impostazioni...
              </div>

              <div v-else class="ai-settings-body">
                <section
                  class="ai-setting-card ai-global-card"
                  :class="{
                    enabled: impostazioniIA.use_datev_new_extractor,
                  }"
                >
                  <div class="ai-setting-main">
                    <span class="ai-setting-icon">
                      <i class="fa-solid fa-file-invoice"></i>
                    </span>
                    <div>
                      <h3>Globale: Prospetti Paghe DATEV</h3>
                      <p>
                        {{
                          impostazioniIA.use_datev_new_extractor
                            ? "Nuovo modello IA attivo per tutti gli utenti"
                            : "Tutti gli utenti usano l'estrattore storico"
                        }}
                      </p>
                    </div>
                  </div>

                  <label class="ai-switch" for="datev-new-extractor-admin">
                    <input
                      id="datev-new-extractor-admin"
                      type="checkbox"
                      v-model="impostazioniIA.use_datev_new_extractor"
                      :disabled="savingImpostazioniIA"
                    />
                    <span class="ai-switch-track">
                      <span class="ai-switch-thumb"></span>
                    </span>
                  </label>
                </section>

                <section
                  class="ai-setting-card ai-global-card"
                  :class="{
                    enabled: impostazioniIA.use_teamsystem_new_extractor,
                  }"
                >
                  <div class="ai-setting-main">
                    <span class="ai-setting-icon">
                      <i class="fa-solid fa-file-invoice"></i>
                    </span>
                    <div>
                      <h3>Globale: Prospetti Paghe TeamSystem</h3>
                      <p>
                        {{
                          impostazioniIA.use_teamsystem_new_extractor
                            ? "Nuovo estrattore attivo per tutti gli utenti"
                            : "Tutti gli utenti usano l'estrattore storico"
                        }}
                      </p>
                    </div>
                  </div>

                  <label class="ai-switch" for="teamsystem-new-extractor-admin">
                    <input
                      id="teamsystem-new-extractor-admin"
                      v-model="impostazioniIA.use_teamsystem_new_extractor"
                      type="checkbox"
                      :disabled="savingImpostazioniIA"
                    />
                    <span class="ai-switch-track">
                      <span class="ai-switch-thumb"></span>
                    </span>
                  </label>
                </section>

                <section
                  class="ai-setting-card ai-global-card"
                  :class="{
                    enabled: impostazioniIA.use_f24_new_extractor,
                  }"
                >
                  <div class="ai-setting-main">
                    <span class="ai-setting-icon">
                      <i class="fa-solid fa-file-invoice-dollar"></i>
                    </span>
                    <div>
                      <h3>Globale: Modelli F24</h3>
                      <p>
                        {{
                          impostazioniIA.use_f24_new_extractor
                            ? "Nuovo modello IA attivo per tutti gli utenti"
                            : "Tutti gli utenti usano l'estrattore storico"
                        }}
                      </p>
                    </div>
                  </div>

                  <label class="ai-switch" for="f24-new-extractor-admin">
                    <input
                      id="f24-new-extractor-admin"
                      type="checkbox"
                      v-model="impostazioniIA.use_f24_new_extractor"
                      :disabled="savingImpostazioniIA"
                    />
                    <span class="ai-switch-track">
                      <span class="ai-switch-thumb"></span>
                    </span>
                  </label>
                </section>

                <section class="ai-admin-overrides">
                  <div class="ai-admin-heading">
                    <div>
                      <h3>Admin MyStudio</h3>
                      <p>
                        Le impostazioni personalizzate qui sotto si applicano
                        solo per noi amministratori.
                      </p>
                    </div>
                  </div>

                  <div
                    v-if="!impostazioniIA.features.length"
                    class="ai-empty-state"
                  >
                    Nessuna feature IA disponibile.
                  </div>
                  <div v-else class="ai-admin-table-wrapper">
                    <table class="ai-admin-table">
                      <thead>
                        <tr>
                          <th>Superadmin</th>
                          <th
                            v-for="feature in impostazioniIA.features"
                            :key="feature.key"
                          >
                            {{ feature.nome }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="admin in impostazioniIA.admins"
                          :key="admin.id"
                          :class="{ current: admin.is_current }"
                        >
                          <td>
                            <div class="ai-admin-user">
                              <strong>{{ admin.display_name }}</strong>
                              <span>{{ admin.email }}</span>
                              <em v-if="admin.is_current">Tu</em>
                            </div>
                          </td>
                          <td
                            v-for="feature in impostazioniIA.features"
                            :key="`${admin.id}-${feature.key}`"
                          >
                            <div class="ai-override-cell">
                              <label class="ai-switch ai-switch-small">
                                <input
                                  type="checkbox"
                                  :checked="
                                    isIaFeatureEnabledForAdmin(
                                      admin,
                                      feature.key
                                    )
                                  "
                                  :disabled="savingImpostazioniIA"
                                  @change="
                                    aggiornaOverrideIAAdmin(
                                      admin,
                                      feature.key,
                                      $event
                                    )
                                  "
                                />
                                <span class="ai-switch-track">
                                  <span class="ai-switch-thumb"></span>
                                </span>
                              </label>
                              <span
                                class="ai-override-source"
                                :class="{
                                  override: hasIaOverride(admin, feature.key),
                                }"
                              >
                                {{
                                  hasIaOverride(admin, feature.key)
                                    ? "Personalizzato"
                                    : "Globale"
                                }}
                              </span>
                              <button
                                v-if="hasIaOverride(admin, feature.key)"
                                type="button"
                                class="ai-reset-override"
                                :disabled="savingImpostazioniIA"
                                @click="
                                  resetOverrideIAAdmin(admin, feature.key)
                                "
                              >
                                Ripristina globale
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <p v-if="messaggioImpostazioniIA" class="settings-feedback">
                  {{ messaggioImpostazioniIA }}
                </p>
              </div>

              <div class="modal-actions ai-settings-actions">
                <button
                  class="btn-cancel"
                  type="button"
                  @click="closeAiSettingsModal"
                >
                  Annulla
                </button>
                <button
                  class="btn-confirm"
                  type="button"
                  :disabled="loadingImpostazioniIA || savingImpostazioniIA"
                  @click="salvaImpostazioniIA"
                >
                  <span v-if="savingImpostazioniIA">Salvataggio...</span>
                  <span v-else>Salva impostazione</span>
                </button>
              </div>
            </div>
          </div>

          <div
            v-if="mostraModalStrumentiTest"
            class="modal-overlayform ai-settings-overlay"
            @click.self="closeTestToolsModal"
          >
            <div
              class="modal-content-news ai-settings-modal test-tools-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="test-tools-title"
            >
              <button
                class="ai-modal-close"
                type="button"
                aria-label="Chiudi strumenti test"
                @click="closeTestToolsModal"
              >
                <i class="fa-solid fa-xmark"></i>
              </button>

              <header class="ai-settings-header test-tools-header">
                <span class="ai-header-icon test-tools-header-icon">
                  <i class="fa-solid fa-flask-vial"></i>
                </span>
                <div class="ai-header-copy">
                  <p>Configurazione riservata</p>
                  <h2 id="test-tools-title">Strumenti test</h2>
                </div>
                <span
                  class="ai-status-badge"
                  :class="{ active: strumentiTestEnabled }"
                >
                  {{ strumentiTestEnabled ? "Attivi" : "Disattivi" }}
                </span>
              </header>

              <div v-if="loadingStrumentiTest" class="ai-settings-loading">
                <span class="ai-loader"></span>
                Caricamento impostazione...
              </div>

              <div v-else class="ai-settings-body test-tools-body">
                <section
                  class="ai-setting-card ai-global-card"
                  :class="{ enabled: strumentiTestEnabled }"
                >
                  <div class="ai-setting-main">
                    <span class="ai-setting-icon test-tools-setting-icon">
                      <img src="/Pagina%20Welcome/logo.png" alt="" />
                    </span>
                    <div>
                      <h3>Pulsante Admin MS nei convertitori</h3>
                      <p>
                        Se attivo, gli admin MyStudio vedono in fase 1 il
                        generatore di Codici Fiscali test per Prospetti Paghe,
                        Modelli F24 e Bilancio Analitico.
                      </p>
                    </div>
                  </div>

                  <label class="ai-switch" for="test-tools-enabled">
                    <input
                      id="test-tools-enabled"
                      v-model="strumentiTestEnabled"
                      type="checkbox"
                      :disabled="savingStrumentiTest"
                    />
                    <span class="ai-switch-track">
                      <span class="ai-switch-thumb"></span>
                    </span>
                  </label>
                </section>

                <p v-if="messaggioStrumentiTest" class="settings-feedback">
                  {{ messaggioStrumentiTest }}
                </p>
              </div>

              <div class="modal-actions ai-settings-actions">
                <button
                  class="btn-cancel"
                  type="button"
                  @click="closeTestToolsModal"
                >
                  Annulla
                </button>
                <button
                  class="btn-confirm"
                  type="button"
                  :disabled="loadingStrumentiTest || savingStrumentiTest"
                  @click="saveTestToolsSetting"
                >
                  <span v-if="savingStrumentiTest">Salvataggio...</span>
                  <span v-else>Salva impostazione</span>
                </button>
              </div>
            </div>
          </div>

          <div v-if="mostraModalMessaggio" class="modal-overlayform">
            <div class="modal-content-news large-modal-content-news">
              <h2>Gestione Notizie</h2>

              <div class="news-manager-layout">
                <div class="news-list-panel">
                  <h3>Tutte le Notizie</h3>
                  <button
                    class="btn-create-new"
                    @click="resetNewsForm"
                    :class="{
                      'selected-action-btn': !editingNews && !selectedNewsId,
                    }"
                  >
                    <i class="fa-solid fa-plus"></i> Crea Nuova Notizia
                  </button>
                  <div v-if="newsList.length === 0" class="no-news-message">
                    Nessuna notizia presente. Clicca "Crea Nuova Notizia" per
                    iniziare!
                  </div>
                  <div class="news-cards-container">
                    <div
                      v-for="news in newsList"
                      :key="news.id"
                      class="news-card"
                      :class="{
                        'active-news': news.is_active,
                        'selected-news': selectedNewsId === news.id,
                      }"
                      @click="loadSelectedNewsCard(news)"
                    >
                      <div class="card-header">
                        <span
                          class="message-type-icon emoji-inline"
                          role="img"
                          :aria-label="getLabelForType(news.message_type)"
                        >
                          {{ getEmojiForType(news.message_type) }}
                        </span>
                        <h4>{{ news.title || "Senza Titolo" }}</h4>
                        <span
                          class="news-status"
                          :class="{
                            'status-active': news.is_active,
                            'status-inactive': !news.is_active,
                          }"
                        >
                          {{ news.is_active ? "Attiva" : "Inattiva" }}
                        </span>
                      </div>
                      <p class="card-preview">
                        {{ truncateText(news.content, 100) }}
                      </p>
                      <div class="card-actions">
                        <button
                          class="btn-edit-small"
                          @click.stop="loadSelectedNewsCard(news)"
                        >
                          Modifica
                        </button>
                        <button
                          class="btn-delete-small"
                          @click.stop="confirmDelete(news.id)"
                        >
                          Elimina
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="news-edit-panel">
                  <h3>
                    {{ editingNews ? "Modifica Notizia" : "Nuova Notizia" }}
                  </h3>
                  <input
                    type="text"
                    v-model="currentNews.title"
                    placeholder="Titolo della Notizia"
                    class="news-title-input"
                    required
                  />
                  <textarea
                    v-model="currentNews.content"
                    rows="10"
                    class="textarea-messaggio"
                    placeholder="Scrivi il contenuto della notizia..."
                  ></textarea>
                  <div class="icon-selector">
                    <p class="messagetypetitle">Tipo di Messaggio:</p>
                    <div class="icon-options">
                      <div
                        v-for="option in iconOptions"
                        :key="option.value"
                        :class="[
                          'icon-option',
                          {
                            selected: currentNews.message_type === option.value,
                          },
                        ]"
                        @click="currentNews.message_type = option.value"
                      >
                        <span
                          class="message-type-icon emoji"
                          role="img"
                          :aria-label="option.label"
                        >
                          {{ getEmojiForType(option.value) }}
                        </span>
                        <span class="label">{{ option.label }}</span>
                      </div>
                    </div>
                  </div>
                  <label class="active-checkbox">
                    <input type="checkbox" v-model="currentNews.is_active" />
                    Attiva notizia
                  </label>

                  <div class="modal-buttons">
                    <button class="btn-salva" @click="saveNews">Salva</button>
                    <button
                      class="btn-annulla"
                      @click="resetNewsForm"
                      v-if="editingNews"
                    >
                      Annulla Modifica
                    </button>
                    <button
                      class="btn-annulla"
                      @click="mostraModalMessaggio = false"
                    >
                      Chiudi
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Form visibile solo se mostraFormRegistrazione è true -->
        <div v-if="mostraFormRegistrazione" class="user-registration-form">
          <h4 class="formtitle registerformtitle">
            <i class="fa-solid fa-user-plus"></i>
            Registra un nuovo utente in MyStudio
          </h4>
          <p class="formsubtitle registration-inline-subtitle">
            Crea un nuovo studio o associa l'utente a uno studio esistente
          </p>

          <div class="toggle-buttons">
            <button
              :class="{ active: tipoRegistrazione === 'nuovo' }"
              @click="
                tipoRegistrazione = 'nuovo';
                newUser.accountType = 'real';
              "
              type="button"
            >
              Crea nuovo studio
            </button>
            <button
              :class="{ active: tipoRegistrazione === 'esistente' }"
              @click="
                tipoRegistrazione = 'esistente';
                newUser.accountType = 'real';
              "
              type="button"
            >
              Associa a studio esistente
            </button>
          </div>
          <!-- Nome e Cognome - sempre visibili, indipendentemente dal tipo -->
          <div class="row-fields">
            <input
              v-model="newUser.firstName"
              placeholder="Nome"
              type="text"
              required
            />
            <input
              v-model="newUser.lastName"
              placeholder="Cognome"
              type="text"
              required
            />
          </div>

          <div
            v-if="tipoRegistrazione === 'nuovo'"
            class="studio-registration-fields"
          >
            <input
              v-model="newUser.studio_name"
              placeholder="Nome Nuovo Studio"
              type="text"
            />
            <input
              v-model.trim="newUser.partita_iva"
              placeholder="Partita IVA (11 cifre)"
              type="text"
              inputmode="numeric"
              pattern="[0-9]{11}"
              maxlength="11"
            />
            <input
              v-model.trim="newUser.indirizzo_sede"
              class="studio-registration-wide"
              placeholder="Indirizzo sede"
              type="text"
              maxlength="255"
            />
            <input
              v-model.trim="newUser.cap"
              placeholder="CAP"
              type="text"
              inputmode="numeric"
              pattern="[0-9]{5}"
              maxlength="5"
            />
            <input
              v-model.trim="newUser.citta"
              placeholder="Città"
              type="text"
              maxlength="100"
            />
            <input
              v-model.trim="newUser.provincia"
              class="studio-registration-province"
              placeholder="Provincia (es. MI)"
              type="text"
              pattern="[A-Za-z]{2}"
              maxlength="2"
            />
          </div>

          <div v-else>
            <input
              v-model="newUser.studio_name"
              placeholder="Nome Studio Esistente"
              type="text"
            />
            <p
              v-if="selectedStudioForRegistration"
              class="studio-test-hint"
              :class="{ active: selectedStudioForRegistration.is_test_studio }"
            >
              {{
                selectedStudioForRegistration.is_test_studio
                  ? "Studio di test: puoi creare utenti reali o utenti test."
                  : "Studio reale: puoi creare solo utenti reali con invito Clerk."
              }}
            </p>
          </div>
          <div v-if="tipoRegistrazione === 'nuovo'">
            <input
              v-model="newUser.email"
              placeholder="Email utente admin"
              type="email"
            />
          </div>

          <div v-else>
            <input
              v-model="newUser.email"
              placeholder="Email utente"
              type="email"
            />
          </div>

          <div
            v-if="
              tipoRegistrazione === 'esistente' &&
              selectedStudioForRegistration?.is_test_studio
            "
            class="account-type-selector"
          >
            <label for="admin-register-account-type">Tipo utenza</label>
            <select
              id="admin-register-account-type"
              v-model="newUser.accountType"
            >
              <option value="real">Utente reale con invito email</option>
              <option value="test">Utente test con password MyStudio</option>
            </select>
          </div>

          <div v-if="isTestUserRegistration" class="password-container">
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="newUser.password"
              placeholder="Password test"
            />
            <i
              :class="
                showPassword ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'
              "
              @click="showPassword = !showPassword"
              class="toggle-password-icon"
            ></i>
          </div>

          <div v-if="isTestUserRegistration" class="password-container">
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="newUser.confirmPassword"
              placeholder="Conferma Password"
            />
          </div>

          <div v-else class="registration-info-box">
            <i class="fa-solid fa-shield-halved"></i>
            <span>
              L'utente riceverà un invito via email. Al primo accesso confermerà
              il proprio indirizzo email e sceglierà la password.
            </span>
          </div>

          <div
            class="registration-plan-field"
            :class="{ hiddenInput: tipoRegistrazione !== 'nuovo' }"
          >
            <select v-model="newUser.tipo_abbonamento">
              <option
                v-for="piano in pianiAbbonamento"
                :key="piano.value"
                :value="piano.value"
              >
                Piano {{ piano.label }}
              </option>
            </select>
          </div>

          <!-- Solo se nuovo studio -->
          <div class="crediti-wrapper">
            <input
              v-model.number="newUser.crediti_disponibili"
              type="number"
              placeholder="Coin Disponibili"
              :class="{ hiddenInput: tipoRegistrazione !== 'nuovo' }"
            />
          </div>

          <div class="registration-actions">
            <button
              type="button"
              class="registration-btn cancel"
              @click="mostraFormRegistrazione = false"
            >
              Annulla
            </button>
            <button @click="registraUtente" class="registration-btn primary">
              <i class="fa-solid fa-user-plus"></i>
              Registra utenti
            </button>
          </div>

          <p v-if="erroreRegistrazione" class="registration-feedback error">
            <i class="fa-solid fa-circle-exclamation"></i>
            {{ erroreRegistrazione }}
          </p>
          <p v-if="confermaRegistrazione" class="registration-feedback success">
            <i class="fa-solid fa-circle-check"></i>
            {{ messaggioRegistrazioneSuccesso }}
          </p>
          <div v-if="lastInvitationLink" class="invitation-link-box">
            <strong>Link invito da inviare all'utente:</strong>
            <textarea :value="lastInvitationLink" readonly></textarea>
            <button
              type="button"
              @click="copyInvitationLink(lastInvitationLink)"
            >
              Copia link invito
            </button>
          </div>
        </div>
        <div v-if="mostraFormPrezzi" class="pricing-form">
          <header class="pricing-header">
            <span class="pricing-header-icon">
              <i class="fa-solid fa-coins"></i>
            </span>
            <div>
              <p>Configurazione commerciale</p>
              <h3>Prezzi MyStudio</h3>
            </div>
            <span class="pricing-status" :class="{ editing: modificaPrezzi }">
              {{ modificaPrezzi ? "Modifica attiva" : "Solo lettura" }}
            </span>
          </header>
          <section class="pricing-section">
            <div class="pricing-section-heading">
              <i class="fa-solid fa-calculator"></i>
              <div>
                <h4>Coin per conversione</h4>
                <p>Costi applicati agli strumenti principali.</p>
              </div>
            </div>
            <div class="pricing-grid">
              <label class="pricing-field">
                <span>Bilancio Analitico</span>
                <input
                  type="number"
                  min="0"
                  v-model.number="prezzi.coin_per_bilancio"
                  :disabled="!modificaPrezzi"
                />
              </label>
              <label class="pricing-field">
                <span>Prospetto Paghe</span>
                <input
                  type="number"
                  min="0"
                  v-model.number="prezzi.coin_per_prospetto"
                  :disabled="!modificaPrezzi"
                />
              </label>
              <label class="pricing-field">
                <span>Modello F24</span>
                <input
                  type="number"
                  min="0"
                  v-model.number="prezzi.coin_per_f24"
                  :disabled="!modificaPrezzi"
                />
              </label>
            </div>
          </section>
          <section class="pricing-section">
            <div class="pricing-section-heading">
              <i class="fa-solid fa-box-open"></i>
              <div>
                <h4>Pacchetti Coin</h4>
                <p>Prezzi di acquisto e costo medio per Coin.</p>
              </div>
            </div>
            <div class="pricing-grid package-grid">
              <label class="pricing-field">
                <span>Prezzo per 1 Coin</span>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  v-model.number="prezzi.prezzo_per_credito"
                  :disabled="!modificaPrezzi"
                />
                <small>EUR / Coin</small>
              </label>
              <label class="pricing-field">
                <span>Pacchetto 10 Coin</span>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  v-model.number="prezzi.prezzo_pacchetto_10"
                  :disabled="!modificaPrezzi"
                />
                <small>
                  {{ (prezzi.prezzo_pacchetto_10 / 10).toFixed(2) }} EUR/Coin
                </small>
              </label>
              <label class="pricing-field">
                <span>Pacchetto 50 Coin</span>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  v-model.number="prezzi.prezzo_pacchetto_50"
                  :disabled="!modificaPrezzi"
                />
                <small>
                  {{ (prezzi.prezzo_pacchetto_50 / 50).toFixed(2) }} EUR/Coin
                </small>
              </label>
              <label class="pricing-field">
                <span>Pacchetto 100 Coin</span>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  v-model.number="prezzi.prezzo_pacchetto_100"
                  :disabled="!modificaPrezzi"
                />
                <small>
                  {{ (prezzi.prezzo_pacchetto_100 / 100).toFixed(2) }} EUR/Coin
                </small>
              </label>
            </div>
          </section>

          <section class="pricing-section">
            <div class="pricing-section-heading">
              <i class="fa-solid fa-layer-group"></i>
              <div>
                <h4>Abbonamenti annuali</h4>
                <p>Importi pubblicati per i piani MyStudio.</p>
              </div>
            </div>
            <div class="pricing-grid plan-grid">
              <label class="pricing-field plan-field">
                <span>Piano Plus</span>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  v-model.number="prezzi.prezzo_piano_plus"
                  :disabled="!modificaPrezzi"
                />
                <small>EUR / anno</small>
              </label>
              <label class="pricing-field plan-field">
                <span>Piano Premium</span>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  v-model.number="prezzi.prezzo_piano_premium"
                  :disabled="!modificaPrezzi"
                />
                <small>EUR / anno</small>
              </label>
            </div>
          </section>

          <footer class="pricing-actions">
            <p v-if="messaggioPrezzi" class="pricing-feedback">
              {{ messaggioPrezzi }}
            </p>
            <div class="pricing-button-row">
              <button
                v-if="!modificaPrezzi"
                class="pricing-btn primary"
                type="button"
                @click="modificaPrezzi = true"
              >
                <i class="fa-solid fa-pen"></i>
                Modifica prezzi
              </button>
              <template v-else>
                <button
                  class="pricing-btn secondary"
                  type="button"
                  @click="annullaModifica"
                >
                  Annulla
                </button>
                <button
                  class="pricing-btn primary"
                  type="button"
                  @click="salvaPrezzi"
                >
                  <i class="fa-solid fa-check"></i>
                  Salva modifiche
                </button>
              </template>
            </div>
          </footer>
        </div>
      </div>
      <div class="table-container">
        <div class="table-header">
          <h3 class="tabletitle">
            Studi registrati in MyStudio
            <span v-if="!isLoading">({{ studi.length }})</span>
          </h3>
          <div class="table-actions">
            <!-- PULSANTE PER SCARICARE EXCEL STUDI -->
            <button @click="scaricaExcelStudiMyStudio" class="download-btn">
              <i class="fa-solid fa-file-excel"></i> Scarica tabella studi
            </button>
          </div>
        </div>
        <table class="studiotable">
          <thead>
            <tr>
              <th
                @click="setSortS('nome')"
                style="cursor: pointer"
                title="Ordina"
              >
                Nome Studio
                <span v-if="sortKeyS === 'nome'">
                  {{ sortAscS ? "↑" : "↓" }}
                </span>
              </th>

              <th>Tipo</th>

              <th
                @click="setSortS('piano_attuale')"
                title="Ordina"
                style="cursor: pointer"
              >
                Piano
                <span v-if="sortKeyS === 'piano_attuale'">
                  {{ sortAscS ? "↑" : "↓" }}
                </span>
              </th>

              <th
                @click="setSortS('crediti_disponibili')"
                title="Ordina"
                style="cursor: pointer"
              >
                Coin disponibili
                <span v-if="sortKeyS === 'crediti_disponibili'">
                  {{ sortAscS ? "↑" : "↓" }}
                </span>
              </th>

              <th
                @click="setSortS('crediti_totali_acquistati')"
                title="Ordina"
                style="cursor: pointer"
              >
                Coin acquistati
                <span v-if="sortKeyS === 'crediti_totali_acquistati'">
                  {{ sortAscS ? "↑" : "↓" }}
                </span>
              </th>

              <th
                @click="setSortS('euro_spesi')"
                style="cursor: pointer"
                title="Ordina"
              >
                Euro spesi
                <span v-if="sortKeyS === 'euro_spesi'">
                  {{ sortAscS ? "↑" : "↓" }}
                </span>
              </th>

              <th
                @click="setSortS('conversioni_totali')"
                title="Ordina"
                style="cursor: pointer"
              >
                Conversioni effettuate
                <span v-if="sortKeyS === 'conversioni_totali'">
                  {{ sortAscS ? "↑" : "↓" }}
                </span>
              </th>
              <th
                @click="setSortS('data_registrazione')"
                title="Ordina"
                style="cursor: pointer"
              >
                Data di Registrazione
                <span v-if="sortKeyS === 'data_registrazione'">
                  {{ sortAscS ? "↑" : "↓" }}
                </span>
              </th>
              <th>Utenti</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="isLoading">
              <tr v-for="n in 5" :key="'skeleton-studio-' + n">
                <td colspan="10"><div class="skeleton-row"></div></td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="studio in studiOrdinati" :key="studio.id">
                <td>{{ studio.nome }}</td>
                <td class="studio-type-cell">
                  <div class="studio-type-container">
                    <select
                      v-if="editStudioTypeMode[studio.id]"
                      v-model="tempStudioType[studio.id]"
                      class="studio-type-select"
                      @keyup.enter="toggleEditStudioType(studio)"
                      @keyup.escape="toggleEditStudioType(studio, true)"
                    >
                      <option value="real">Reale</option>
                      <option value="test">Test</option>
                    </select>
                    <span
                      v-else
                      class="studio-type-badge"
                      :class="{ test: studio.is_test_studio }"
                    >
                      <i
                        :class="
                          studio.is_test_studio
                            ? 'fa-solid fa-flask'
                            : 'fa-solid fa-building'
                        "
                      ></i>
                      {{ studio.is_test_studio ? "Test" : "Reale" }}
                    </span>

                    <button
                      type="button"
                      class="toggle-edit-btn"
                      :class="{ editing: editStudioTypeMode[studio.id] }"
                      :disabled="studio.nome === 'MyStudio'"
                      @click="toggleEditStudioType(studio)"
                      :title="
                        editStudioTypeMode[studio.id]
                          ? 'Salva tipo studio'
                          : 'Modifica tipo studio'
                      "
                    >
                      <span v-if="editStudioTypeMode[studio.id]">✓</span>
                      <span v-else>✎</span>
                    </button>
                    <button
                      v-if="editStudioTypeMode[studio.id]"
                      type="button"
                      class="cancel-edit-btn"
                      @click="toggleEditStudioType(studio, true)"
                      title="Annulla modifiche"
                    >
                      ×
                    </button>
                  </div>
                </td>
                <td class="piano-cell">
                  <div class="piano-container">
                    <select
                      v-if="editPianoMode[studio.id]"
                      v-model="tempPiano[studio.id]"
                      class="piano-select"
                      @keyup.enter="toggleEditPiano(studio)"
                      @keyup.escape="toggleEditPiano(studio, true)"
                    >
                      <option
                        v-for="piano in pianiAbbonamento"
                        :key="piano.value"
                        :value="piano.value"
                      >
                        {{ piano.label }}
                      </option>
                    </select>
                    <span
                      v-else
                      class="piano-badge"
                      :class="pianoClass(studio)"
                    >
                      {{ formatPiano(studio.piano_attuale || studio.piano) }}
                    </span>

                    <button
                      type="button"
                      class="toggle-edit-btn"
                      :class="{ editing: editPianoMode[studio.id] }"
                      @click="toggleEditPiano(studio)"
                      :title="
                        editPianoMode[studio.id]
                          ? 'Salva piano'
                          : 'Modifica piano'
                      "
                    >
                      <span v-if="editPianoMode[studio.id]">✓</span>
                      <span v-else>✎</span>
                    </button>
                    <button
                      v-if="editPianoMode[studio.id]"
                      type="button"
                      class="cancel-edit-btn"
                      @click="toggleEditPiano(studio, true)"
                      title="Annulla modifiche"
                    >
                      ×
                    </button>
                  </div>
                </td>
                <td class="coin-cell">
                  <div class="coin-container">
                    <div class="coin-value-wrapper">
                      <input
                        v-if="editCoinMode[studio.id]"
                        type="number"
                        v-model.number="studio.crediti_disponibili"
                        :class="{ modified: isModified(studio) }"
                        @blur="normalizeCrediti(studio)"
                        @keyup.enter="toggleEditCoin(studio)"
                        @keyup.escape="toggleEditCoin(studio, true)"
                        min="0"
                        placeholder="0"
                        class="coin-input"
                        autofocus
                      />
                      <span v-else class="coin-display">
                        {{ studio.crediti_disponibili ?? 0 }}
                      </span>
                    </div>

                    <button
                      type="button"
                      class="toggle-edit-btn"
                      :class="{ editing: editCoinMode[studio.id] }"
                      @click="toggleEditCoin(studio)"
                      :title="
                        editCoinMode[studio.id]
                          ? 'Salva modifica'
                          : 'Modifica coin'
                      "
                    >
                      <span v-if="editCoinMode[studio.id]">✓</span>
                      <span v-else>✎</span>
                    </button>
                    <button
                      v-if="editCoinMode[studio.id]"
                      type="button"
                      class="cancel-edit-btn"
                      @click="toggleEditCoin(studio, true)"
                      title="Annulla modifiche"
                    >
                      ×
                    </button>
                  </div>
                </td>
                <td>{{ studio.crediti_totali_acquistati }}</td>
                <td>{{ studio.euro_spesi.toFixed(2) }} €</td>
                <td>
                  <div class="conversioni-cell">
                    <button
                      type="button"
                      class="conversioni-total"
                      :aria-expanded="
                        activeConversionDetails === `studio:${studio.id}`
                      "
                      @click.stop="
                        toggleConversionDetails(`studio:${studio.id}`, $event)
                      "
                      :aria-label="`Conversioni totali: ${totaleConversioniStudio(
                        studio
                      )}. Mostra dettaglio conversioni`"
                    >
                      {{ totaleConversioniStudio(studio) }}
                    </button>
                    <div
                      v-if="activeConversionDetails === `studio:${studio.id}`"
                      class="conversioni-popover"
                      :style="conversionPopoverStyle"
                      role="status"
                    >
                      <strong>Conversioni</strong>
                      <span>
                        Prospetti Paghe
                        <b>{{ studio.conversioni_effettuate_prospetti }}</b>
                      </span>
                      <span>
                        Modelli F24
                        <b>{{ studio.conversioni_effettuate_f24 }}</b>
                      </span>
                      <span>
                        Bilanci Analitici
                        <b>{{ studio.conversioni_effettuate_bilanci }}</b>
                      </span>
                    </div>
                  </div>
                </td>
                <td>{{ formatDate(studio.data_registrazione) }}</td>
                <td style="white-space: nowrap">
                  <button class="link-button" @click="mostraUtenti(studio)">
                    Utenti ({{ studio.utenti.length }})
                  </button>
                </td>
                <td>
                  <div class="table-wrapper azioni-compatte">
                    <button
                      class="btn-azione btn-elimina"
                      @click="chiediConfermaEliminaStudio(studio)"
                      :disabled="studio.nome === 'MyStudio'"
                      :title="
                        studio.nome === 'MyStudio'
                          ? 'Lo studio MyStudio non può essere eliminato'
                          : 'Elimina studio'
                      "
                    >
                      <i class="fa-solid fa-trash-can"></i>
                      <!-- Opzionale: testo piccolo sotto o tooltip -->
                      <!-- <span class="btn-label">Elimina</span> -->
                    </button>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div v-if="modalUtentiVisibile" class="modal-overlayform">
          <div class="modal-content-news">
            <h3>{{ studioSelezionato.nome }}</h3>
            <p
              v-if="studioSelezionato.utenti.length > 1"
              class="utentiregistrati"
            >
              {{ studioSelezionato.utenti.length }} utenti registrati
            </p>
            <p v-else class="utentiregistrati">
              {{ studioSelezionato.utenti.length }} utente registrato
            </p>
            <ul>
              <li v-for="utente in studioSelezionato.utenti" :key="utente">
                {{ utente }}
              </li>
            </ul>
            <button @click="modalUtentiVisibile = false" class="btn">
              Chiudi
            </button>
          </div>
        </div>
      </div>
      <div class="table-container2">
        <div class="table-header">
          <h3 class="tabletitle">
            Utenti registrati in MyStudio
            <span v-if="!isLoading">({{ utenti.length }})</span>
          </h3>
          <div class="table-actions">
            <!-- PULSANTE PER SCARICARE EXCEL -->
            <button @click="scaricaExcelUtentiMyStudio" class="download-btn">
              <i class="fa-solid fa-file-excel"></i> Scarica tabella utenti
            </button>
          </div>
        </div>
        <table class="usertable">
          <thead>
            <tr>
              <th @click="setSortU('email')" style="cursor: pointer">
                Email
                <span v-if="sortKeyU === 'email'">{{
                  sortAscU ? "↑" : "↓"
                }}</span>
              </th>

              <th @click="setSortU('nome')" style="cursor: pointer">
                Nome
                <span v-if="sortKeyU === 'nome'">{{
                  sortAscU ? "↑" : "↓"
                }}</span>
              </th>

              <th @click="setSortU('codice_fiscale')" style="cursor: pointer">
                Codice fiscale
                <span v-if="sortKeyU === 'codice_fiscale'">{{
                  sortAscU ? "↑" : "↓"
                }}</span>
              </th>

              <th style="cursor: pointer">
                <div @click="setSortU('studio_name')">
                  Studio
                  <span v-if="sortKeyU === 'studio_name'">{{
                    sortAscU ? "↑" : "↓"
                  }}</span>
                </div>
                <!-- <select v-model="filtroStudio">
                  <option value="">Tutti</option>
                  <option v-for="nome in studiUnici" :key="nome" :value="nome">
                    {{ nome }}
                  </option>
                </select> -->
              </th>

              <th @click="setSortU('ruolo')" style="cursor: pointer">
                Ruolo
                <span v-if="sortKeyU === 'ruolo'">{{
                  sortAscU ? "↑" : "↓"
                }}</span>
              </th>

              <th @click="setSortU('auth_provider')" style="cursor: pointer">
                Stato
                <span v-if="sortKeyU === 'auth_provider'">{{
                  sortAscU ? "↑" : "↓"
                }}</span>
              </th>

              <th
                @click="setSortU('data_registrazione')"
                style="cursor: pointer"
              >
                Data di registrazione
                <span v-if="sortKeyU === 'data_registrazione'">{{
                  sortAscU ? "↑" : "↓"
                }}</span>
              </th>
              <th
                @click="setSortU('conversioni_totali')"
                style="cursor: pointer"
              >
                Conversioni effettuate
                <span v-if="sortKeyU === 'conversioni_totali'">{{
                  sortAscU ? "↑" : "↓"
                }}</span>
              </th>
              <th>Storico Operazioni</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="isLoading">
              <tr v-for="n in 5" :key="'skeleton-utente-' + n">
                <td colspan="10"><div class="skeleton-row"></div></td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="utente in utentiOrdinati" :key="utente.email">
                <td>{{ utente.email }}</td>
                <td>{{ userFullName(utente) }}</td>
                <td>{{ utente.codice_fiscale || "—" }}</td>
                <td>{{ utente.studio_name }}</td>
                <td class="ruolo-cell">
                  <div class="ruolo-container">
                    <div class="ruolo-value-wrapper">
                      <!-- Durante editing: select con valore temporaneo -->
                      <select
                        v-if="editRuoloMode[utente.email]"
                        v-model="tempRuolo[utente.email]"
                        class="ruolo-select"
                        autofocus
                        @keyup.enter="toggleEditRuolo(utente)"
                        @keyup.escape="toggleEditRuolo(utente, true)"
                      >
                        <option value="admin">admin</option>
                        <option value="utente">utente</option>
                      </select>

                      <!-- Fuori editing: mostra valore reale (con testo speciale per adminMyStudio) -->
                      <span v-else class="ruolo-display">
                        <span
                          v-if="utente.ruolo_originale === 'adminMyStudio'"
                          class="admin-fixed"
                        >
                          adminMyStudio
                        </span>
                        <template v-else>
                          {{ utente.ruolo }}
                        </template>
                      </span>
                    </div>

                    <!-- Pulsante toggle matita / spunta (solo se modificabile) -->
                    <button
                      v-if="utente.ruolo_originale !== 'adminMyStudio'"
                      type="button"
                      class="toggle-edit-btn"
                      :class="{ editing: editRuoloMode[utente.email] }"
                      @click="toggleEditRuolo(utente)"
                      :title="
                        editRuoloMode[utente.email]
                          ? 'Salva ruolo'
                          : 'Modifica ruolo'
                      "
                    >
                      <span v-if="editRuoloMode[utente.email]">✓</span>
                      <span v-else>✎</span>
                    </button>

                    <!-- Pulsante annulla × (solo visibile in editing) -->
                    <button
                      v-if="editRuoloMode[utente.email]"
                      type="button"
                      class="cancel-edit-btn"
                      @click="toggleEditRuolo(utente, true)"
                      title="Annulla modifica"
                    >
                      ×
                    </button>
                  </div>
                </td>
                <td>
                  <span
                    class="admin-user-status-badge"
                    :class="userInvitationStatusClass(utente)"
                  >
                    {{ userInvitationStatusLabel(utente) }}
                  </span>
                </td>
                <td>{{ formatDate(utente.data_registrazione) }}</td>
                <td>
                  <div class="conversioni-cell">
                    <button
                      type="button"
                      class="conversioni-total"
                      :aria-expanded="
                        activeConversionDetails === `utente:${utente.email}`
                      "
                      @click.stop="
                        toggleConversionDetails(
                          `utente:${utente.email}`,
                          $event
                        )
                      "
                      :aria-label="`Conversioni totali: ${totaleConversioniUtente(
                        utente
                      )}. Mostra dettaglio conversioni`"
                    >
                      {{ totaleConversioniUtente(utente) }}
                    </button>
                    <div
                      v-if="
                        activeConversionDetails === `utente:${utente.email}`
                      "
                      class="conversioni-popover"
                      :style="conversionPopoverStyle"
                      role="status"
                    >
                      <strong>Conversioni</strong>
                      <span>
                        Prospetti Paghe
                        <b>{{ utente.conversioni_effettuate_prospetti }}</b>
                      </span>
                      <span>
                        Modelli F24
                        <b>{{ utente.conversioni_effettuate_f24 }}</b>
                      </span>
                      <span>
                        Bilanci Analitici
                        <b>{{ utente.conversioni_effettuate_bilanci }}</b>
                      </span>
                    </div>
                  </div>
                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="storico-btn"
                    @click="apriStoricoOperazioni(utente.email)"
                    title="Vedi storico operazioni"
                  >
                    <i class="fa-solid fa-clock-rotate-left"></i>
                  </button>
                </td>
                <td>
                  <div class="actions-menu-wrapper">
                    <button
                      class="btn-azione btn-menu-utente"
                      title="Azioni utente"
                      :aria-expanded="activeUserActionsMenu === utente.email"
                      @click.stop="toggleUserActionsMenu(utente, $event)"
                    >
                      <i class="fa-solid fa-ellipsis"></i>
                    </button>
                    <div
                      v-if="activeUserActionsMenu === utente.email"
                      class="user-actions-dropdown"
                      :style="userActionsMenuStyle"
                    >
                      <button @click="apriDettagliUtente(utente)">
                        Visualizza dettagli
                      </button>
                      <button
                        v-if="canResetTestUserPassword(utente)"
                        @click="apriResetPasswordTest(utente)"
                      >
                        Reset password
                      </button>
                      <button
                        v-else-if="utente.auth_provider === 'pending_clerk'"
                        @click="reinviaInvitoUtente(utente)"
                      >
                        Reinvia invito
                      </button>
                      <button
                        v-else-if="canConvertUserToTest(utente)"
                        @click="apriConversioneUtenteTest(utente)"
                      >
                        Rendi utente test
                      </button>
                      <button
                        v-else-if="utente.auth_provider === 'clerk'"
                        @click="mostraInfoResetClerk(utente)"
                      >
                        Invia reset password
                      </button>
                      <button
                        class="danger"
                        :disabled="utente.ruolo_originale === 'adminMyStudio'"
                        @click="chiediConfermaElimina(utente)"
                      >
                        Elimina utente
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <transition name="fade">
          <div
            v-if="storicoModalVisibile"
            class="modal-overlay"
            @click.self="chiudiStoricoModal"
          >
            <div class="modal-content-storico">
              <h3>Storico operazioni di {{ storicoModalUtenteEmail }}</h3>
              <button class="close-btn" @click="chiudiStoricoModal">×</button>
              <table class="download-log-table">
                <thead>
                  <tr>
                    <th>Tipo di Operazione</th>
                    <th>File Caricato</th>
                    <th>File Elaborato</th>
                    <th>Data Operazione</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="isLoadingStorico">
                    <td colspan="4" class="operationtext">
                      <div class="loader-wrapper">
                        <div class="loader"></div>
                        <span>Caricamento in corso...</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-else-if="storicoOperazioni.length === 0">
                    <td colspan="4" class="operationtext">
                      Nessuna operazione effettuata.
                    </td>
                  </tr>
                  <template v-for="log in storicoOperazioni">
                    <tr :key="log.id">
                      <td>{{ log.operazione }}</td>
                      <td>{{ log.file_name }}</td>
                      <td
                        @click="
                          log.file_scaricati && log.file_scaricati.length > 1
                            ? toggleExpand(log.id)
                            : null
                        "
                        :class="{
                          'clickable-cell':
                            log.file_scaricati && log.file_scaricati.length > 1,
                        }"
                      >
                        <template v-if="Array.isArray(log.file_scaricati)">
                          <template v-if="log.file_scaricati.length === 1">
                            {{ log.file_scaricati[0] }}
                          </template>
                          <template v-else-if="log.file_scaricati.length > 1">
                            <span class="chip">
                              {{ log.file_scaricati.length }} file
                            </span>
                          </template>
                          <template v-else>Nessun file scaricato</template>
                        </template>
                        <template v-else>Nessun file scaricato</template>
                      </td>
                      <td>{{ formatDate(log.download_date) }}</td>
                    </tr>
                    <tr v-if="isExpanded(log.id)" :key="'expanded-' + log.id">
                      <td colspan="4" class="expanded-row">
                        <span class="filescaricatititle">File scaricati:</span>
                        <ul>
                          <li
                            v-for="(file, index) in log.file_scaricati || []"
                            :key="`${log.id}-${file}-${index}`"
                          >
                            {{ file }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </transition>

        <!-- Modal di conferma -->
        <div v-if="modalVisibile" class="modal-overlay">
          <div
            class="modal-content-news"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modalTitle"
            aria-describedby="modalDesc"
          >
            <h3 id="modalTitle">{{ modalTitolo }}</h3>
            <p id="modalDesc">{{ modalMessaggio }}</p>
            <button @click="confermaAzione" class="btn btn-confirm">
              Conferma
            </button>
            <button @click="annullaAzione" class="btn btn-cancel">
              Annulla
            </button>
          </div>
        </div>

        <div v-if="convertTestModalVisibile" class="modal-overlay">
          <div
            class="modal-content-news convert-test-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="convertTestTitle"
          >
            <h3 id="convertTestTitle">Rendi utente test</h3>
            <p>
              Imposta una nuova password MyStudio per
              <strong>{{ convertTestUtente?.email }}</strong
              >. L'account verrà scollegato dall'autenticazione esterna e potrà
              accedere come utente test dello studio.
            </p>
            <input
              v-model="convertTestPassword"
              type="password"
              placeholder="Nuova password test"
              autocomplete="new-password"
            />
            <input
              v-model="convertTestConfirmPassword"
              type="password"
              placeholder="Conferma password test"
              autocomplete="new-password"
            />
            <p v-if="convertTestError" class="convert-test-error">
              {{ convertTestError }}
            </p>
            <div class="modal-actions">
              <button
                @click="convertiUtenteInTest"
                class="btn btn-confirm"
                :disabled="convertTestLoading"
              >
                {{ convertTestLoading ? "Conversione..." : "Conferma" }}
              </button>
              <button
                @click="chiudiConversioneUtenteTest"
                class="btn btn-cancel"
                :disabled="convertTestLoading"
              >
                Annulla
              </button>
            </div>
          </div>
        </div>

        <div v-if="resetTestModalVisibile" class="modal-overlay">
          <div
            class="modal-content-news convert-test-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="resetTestTitle"
          >
            <h3 id="resetTestTitle">Reset password test</h3>
            <p>
              Imposta una nuova password MyStudio per
              <strong>{{ resetTestUtente?.email }}</strong
              >. L'utente accederà come utente test dello studio.
            </p>
            <input
              v-model="resetTestPassword"
              type="password"
              placeholder="Nuova password"
              autocomplete="new-password"
            />
            <input
              v-model="resetTestConfirmPassword"
              type="password"
              placeholder="Conferma password"
              autocomplete="new-password"
            />
            <p v-if="resetTestError" class="convert-test-error">
              {{ resetTestError }}
            </p>
            <div class="modal-actions">
              <button
                @click="resetPasswordUtenteTest"
                class="btn btn-confirm"
                :disabled="resetTestLoading"
              >
                {{ resetTestLoading ? "Salvataggio..." : "Conferma" }}
              </button>
              <button
                @click="chiudiResetPasswordTest"
                class="btn btn-cancel"
                :disabled="resetTestLoading"
              >
                Annulla
              </button>
            </div>
          </div>
        </div>

        <div
          v-if="dettagliUtenteModalVisibile"
          class="modal-overlay"
          @click.self="chiudiDettagliUtente"
        >
          <div
            class="modal-content-news user-details-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="userDetailsTitle"
          >
            <h3 id="userDetailsTitle">Dettagli utente</h3>
            <div class="user-details-grid">
              <span>Nome</span>
              <strong>{{ dettagliUtente?.first_name || "—" }}</strong>
              <span>Cognome</span>
              <strong>{{ dettagliUtente?.last_name || "—" }}</strong>
              <span>Email</span>
              <strong>{{ dettagliUtente?.email || "—" }}</strong>
              <span>Acquisti in App</span>
              <strong>{{
                dettagliUtente?.puo_fare_acquisti ? "Sì" : "No"
              }}</strong>
              <span>Modifica impostazioni App</span>
              <strong>
                {{ dettagliUtente?.can_manage_studio_settings ? "Sì" : "No" }}
              </strong>
              <span>Stato</span>
              <strong>{{
                userInvitationStatusLabel(dettagliUtente || {})
              }}</strong>
              <span>Data di registrazione</span>
              <strong>{{
                formatDate(dettagliUtente?.data_registrazione)
              }}</strong>
              <span>Conversioni Prospetti Paghe</span>
              <strong>{{
                dettagliUtente?.conversioni_effettuate_prospetti || 0
              }}</strong>
              <span>Conversioni Modelli F24</span>
              <strong>{{
                dettagliUtente?.conversioni_effettuate_f24 || 0
              }}</strong>
              <span>Conversioni Bilanci Analitici</span>
              <strong>{{
                dettagliUtente?.conversioni_effettuate_bilanci || 0
              }}</strong>
            </div>
            <div class="modal-actions">
              <button @click="chiudiDettagliUtente" class="btn btn-confirm">
                Chiudi
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <br />
    <div>
      <br />
      <br />
    </div>
    <SuccessMessage
      :message="successModalMessaggio"
      :isVisible="successModalVisibile"
      @close="successModalVisibile = false"
    />
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "@/config.js";
import SuccessMessage from "../components/SuccessMessage.vue";
import { floatingTablePanelStyle } from "@/utils/floatingTablePanel";
import { withVisibleConvertedFiles } from "@/utils/downloadLogs";
export default {
  name: "AreaAmministratore",
  components: {
    SuccessMessage,
  },
  data() {
    return {
      studi: [],
      utenti: [],
      sortKeyS: "nome",
      sortAscS: true,
      sortKeyU: "studio_name",
      sortAscU: true,
      filtroStudio: "",
      isLoading: false,
      tipoRegistrazione: "nuovo",
      studiEsistenti: [],
      originalStudi: [],
      modalUtentiVisibile: false,
      storicoOperazioni: [],
      isLoadingStorico: false,
      storicoModalVisibile: false,
      storicoModalUtenteEmail: "",
      expandedRows: [],
      newUser: {
        firstName: "",
        lastName: "",
        email: "",
        accountType: "real",
        password: "",
        confirmPassword: "",
        crediti_disponibili: null,
        studio_name: "",
        tipo_abbonamento: "base",
        partita_iva: "",
        indirizzo_sede: "",
        cap: "",
        citta: "",
        provincia: "",
      },
      mostraFormRegistrazione: false,
      mostraFormPrezzi: false,
      mostraModalMessaggio: false,
      mostraModalImpostazioniIA: false,
      mostraModalStrumentiTest: false,
      strumentiTestEnabled: false,
      strumentiTestOriginal: false,
      loadingStrumentiTest: false,
      savingStrumentiTest: false,
      messaggioStrumentiTest: "",
      impostazioniIA: {
        use_datev_new_extractor: false,
        use_teamsystem_new_extractor: true,
        use_f24_new_extractor: false,
        features: [],
        admins: [],
      },
      loadingImpostazioniIA: false,
      savingImpostazioniIA: false,
      messaggioImpostazioniIA: "",
      messaggioGlobale: "",
      newsList: [],
      selectedNewsId: null,
      currentNews: {
        // L'oggetto per il form di creazione/modifica
        id: null,
        title: "",
        content: "", // Corrispondera a 'text' nel backend
        is_active: true,
        message_type: "notizia",
      },
      editingNews: false,
      erroreRegistrazione: "",
      confermaRegistrazione: false,
      messaggioRegistrazioneSuccesso: "",
      lastInvitationLink: "",
      showPassword: false,
      modalVisibile: false,
      modalTitolo: "",
      modalMessaggio: "",
      azioneDaConfermare: null,
      iaActionPending: null,
      studioSelezionato: null,
      utenteSelezionato: null,
      convertTestModalVisibile: false,
      convertTestUtente: null,
      convertTestPassword: "",
      convertTestConfirmPassword: "",
      convertTestError: "",
      convertTestLoading: false,
      resetTestModalVisibile: false,
      resetTestUtente: null,
      resetTestPassword: "",
      resetTestConfirmPassword: "",
      resetTestError: "",
      resetTestLoading: false,
      dettagliUtenteModalVisibile: false,
      dettagliUtente: null,
      activeUserActionsMenu: null,
      userActionsMenuStyle: {},
      activeConversionDetails: null,
      conversionPopoverStyle: {},
      prezzi: {
        prezzo_per_credito: 0,
        prezzo_pacchetto_10: 0,
        prezzo_pacchetto_50: 0,
        prezzo_pacchetto_100: 0,
        coin_per_f24: 0,
        coin_per_prospetto: 0,
        coin_per_bilancio: 0,
        prezzo_piano_plus: 0, // Added for Plus plan
        prezzo_piano_premium: 0, // Added for Premium plan
      },
      editCoinMode: {},
      editPianoMode: {},
      editStudioTypeMode: {},
      editRuoloMode: {},
      tempRuolo: {},
      tempPiano: {},
      tempStudioType: {},
      pianiAbbonamento: [
        { value: "base", label: "Base" },
        { value: "plus", label: "Plus" },
        { value: "premium", label: "Premium" },
      ],
      modificaPrezzi: false,
      messaggioPrezzi: "",
      successModalVisibile: false,
      successModalMessaggio: "",
      message_type: "notizia",
      iconOptions: [
        {
          value: "notizia",
          label: "Notizia",
          codePoints: [0x1f4f0],
        },
        {
          value: "aggiornamento",
          label: "Aggiornamento",
          codePoints: [0x1f6e0, 0xfe0f],
        },
        {
          value: "alert",
          label: "Avviso",
          codePoints: [0x1f4e2],
        },
        {
          value: "evento",
          label: "Evento",
          codePoints: [0x1f4c5],
        },
      ],
    };
  },
  computed: {
    isAdminMyStudio() {
      return JSON.parse(localStorage.getItem("isAdminMyStudio") || "false");
    },
    studiOrdinati() {
      return [...this.studi].sort((a, b) => {
        const key = this.sortKeyS;
        let aValue =
          key === "conversioni_totali"
            ? this.totaleConversioniStudio(a)
            : a[key];
        let bValue =
          key === "conversioni_totali"
            ? this.totaleConversioniStudio(b)
            : b[key];

        // Conversioni per gestire tipi diversi
        if (typeof aValue === "string") {
          aValue = aValue.toLowerCase();
          bValue = bValue.toLowerCase();
        }
        if (key === "data_registrazione") {
          aValue = new Date(aValue);
          bValue = new Date(bValue);
        }

        const result = aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
        return this.sortAscS ? result : -result;
      });
    },
    utentiOrdinati() {
      return [...this.utenti]
        .filter((u) => {
          // Filtro per studio
          return (
            this.filtroStudio === "" || u.studio_name === this.filtroStudio
          );
        })
        .sort((a, b) => {
          let valA =
            this.sortKeyU === "conversioni_totali"
              ? this.totaleConversioniUtente(a)
              : this.sortKeyU === "nome"
              ? this.userFullName(a)
              : a[this.sortKeyU];
          let valB =
            this.sortKeyU === "conversioni_totali"
              ? this.totaleConversioniUtente(b)
              : this.sortKeyU === "nome"
              ? this.userFullName(b)
              : b[this.sortKeyU];

          if (valA === null || valA === undefined) valA = "";
          if (valB === null || valB === undefined) valB = "";

          // Normalizza
          if (typeof valA === "string") {
            valA = valA.toLowerCase();
            valB = String(valB).toLowerCase();
          }
          if (this.sortKeyU === "data_registrazione") {
            valA = new Date(valA);
            valB = new Date(valB);
          }

          const result = valA > valB ? 1 : valA < valB ? -1 : 0;
          return this.sortAscU ? result : -result;
        });
    },

    // Per popolare il filtro Studio
    studiUnici() {
      const nomi = this.utenti.map((u) => u.studio_name);
      return [...new Set(nomi)].sort();
    },
    selectedStudioForRegistration() {
      if (this.tipoRegistrazione !== "esistente" || !this.newUser.studio_name) {
        return null;
      }

      return (
        this.studi.find((studio) => studio.nome === this.newUser.studio_name) ||
        null
      );
    },
    isTestUserRegistration() {
      return (
        this.newUser.accountType === "test" &&
        this.tipoRegistrazione === "esistente" &&
        !!this.selectedStudioForRegistration?.is_test_studio
      );
    },
    hasUnsavedChanges() {
      const utentiModificati = this.utenti.some(
        (utente) => utente.ruolo !== utente.ruolo_originale
      );

      const studiModificati = this.studi.some((studio) => {
        const originale = this.originalStudi.find((s) => s.id === studio.id);
        return (
          originale &&
          studio.crediti_disponibili !== originale.crediti_disponibili
        );
      });

      return utentiModificati || studiModificati;
    },
  },
  methods: {
    async openNewsAdminModal() {
      this.mostraModalMessaggio = true;
      this.mostraFormPrezzi = false;
      this.mostraFormRegistrazione = false;
      this.mostraModalImpostazioniIA = false;
      this.mostraModalStrumentiTest = false;
      await this.fetchNewsList(); // Carica tutte le notizie all'apertura del modale
      this.resetNewsForm(); // Resetta il form per la creazione di una nuova notizia di default
    },
    async openAiSettingsModal() {
      this.mostraModalImpostazioniIA = true;
      this.mostraModalMessaggio = false;
      this.mostraFormPrezzi = false;
      this.mostraFormRegistrazione = false;
      this.mostraModalStrumentiTest = false;
      this.messaggioImpostazioniIA = "";
      await this.caricaImpostazioniIA();
    },
    closeAiSettingsModal() {
      if (this.savingImpostazioniIA) return;
      this.mostraModalImpostazioniIA = false;
      this.messaggioImpostazioniIA = "";
    },
    async openTestToolsModal() {
      this.mostraModalStrumentiTest = true;
      this.mostraModalMessaggio = false;
      this.mostraModalImpostazioniIA = false;
      this.mostraFormPrezzi = false;
      this.mostraFormRegistrazione = false;
      this.messaggioStrumentiTest = "";
      this.loadingStrumentiTest = true;
      try {
        const response = await axios.get(
          `${API_BASE_URL}/superadmin/test_tools_setting`
        );
        this.strumentiTestEnabled = !!response.data.enabled;
        this.strumentiTestOriginal = this.strumentiTestEnabled;
      } catch (error) {
        console.error("Errore nel caricamento strumenti test:", error);
        this.messaggioStrumentiTest =
          "Errore nel caricamento dell'impostazione.";
      } finally {
        this.loadingStrumentiTest = false;
      }
    },
    closeTestToolsModal() {
      if (this.savingStrumentiTest) return;
      this.strumentiTestEnabled = this.strumentiTestOriginal;
      this.mostraModalStrumentiTest = false;
      this.messaggioStrumentiTest = "";
    },
    async saveTestToolsSetting() {
      this.savingStrumentiTest = true;
      this.messaggioStrumentiTest = "";
      try {
        const response = await axios.post(
          `${API_BASE_URL}/superadmin/test_tools_setting`,
          { enabled: this.strumentiTestEnabled }
        );
        this.strumentiTestEnabled = !!response.data.enabled;
        this.strumentiTestOriginal = this.strumentiTestEnabled;
        this.messaggioStrumentiTest = "Impostazione aggiornata.";
        this.successModalMessaggio = this.strumentiTestEnabled
          ? "Strumenti test attivati per gli admin MyStudio"
          : "Strumenti test disattivati";
        this.successModalVisibile = true;
      } catch (error) {
        console.error("Errore nel salvataggio strumenti test:", error);
        this.messaggioStrumentiTest =
          error.response?.data?.error ||
          "Errore nel salvataggio dell'impostazione.";
      } finally {
        this.savingStrumentiTest = false;
      }
    },
    async caricaImpostazioniIA() {
      this.loadingImpostazioniIA = true;
      try {
        const res = await axios.get(
          `${API_BASE_URL}/superadmin/datev_extractor_setting`
        );
        this.impostazioniIA.use_datev_new_extractor =
          !!res.data.use_datev_new_extractor;
        this.impostazioniIA.use_teamsystem_new_extractor =
          !!res.data.use_teamsystem_new_extractor;
        this.impostazioniIA.use_f24_new_extractor =
          !!res.data.use_f24_new_extractor;
        this.impostazioniIA.features = res.data.features || [];
        this.impostazioniIA.admins = res.data.admins || [];
      } catch (error) {
        console.error("Errore nel caricamento impostazioni IA:", error);
        this.messaggioImpostazioniIA =
          "Errore nel caricamento delle impostazioni IA";
      } finally {
        this.loadingImpostazioniIA = false;
      }
    },
    async salvaImpostazioniIA() {
      this.savingImpostazioniIA = true;
      this.messaggioImpostazioniIA = "";
      try {
        const res = await axios.post(
          `${API_BASE_URL}/superadmin/datev_extractor_setting`,
          {
            use_datev_new_extractor:
              this.impostazioniIA.use_datev_new_extractor,
            use_teamsystem_new_extractor:
              this.impostazioniIA.use_teamsystem_new_extractor,
            use_f24_new_extractor: this.impostazioniIA.use_f24_new_extractor,
          }
        );
        this.impostazioniIA.use_datev_new_extractor =
          !!res.data.use_datev_new_extractor;
        this.impostazioniIA.use_teamsystem_new_extractor =
          !!res.data.use_teamsystem_new_extractor;
        this.impostazioniIA.use_f24_new_extractor =
          !!res.data.use_f24_new_extractor;
        if (res.data.features) this.impostazioniIA.features = res.data.features;
        if (res.data.admins) this.impostazioniIA.admins = res.data.admins;
        this.successModalMessaggio = res.data.message;
        this.successModalVisibile = true;
        this.messaggioImpostazioniIA = "Impostazione aggiornata";
      } catch (error) {
        console.error("Errore nel salvataggio impostazioni IA:", error);
        this.messaggioImpostazioniIA =
          "Errore nel salvataggio delle impostazioni IA";
      } finally {
        this.savingImpostazioniIA = false;
      }
    },
    hasIaOverride(admin, featureKey) {
      return (
        admin &&
        admin.overrides &&
        Object.prototype.hasOwnProperty.call(admin.overrides, featureKey)
      );
    },
    isIaFeatureEnabledForAdmin(admin, featureKey) {
      if (this.hasIaOverride(admin, featureKey)) {
        return !!admin.overrides[featureKey];
      }
      if (featureKey === "ia.modelli_f24") {
        return !!this.impostazioniIA.use_f24_new_extractor;
      }
      if (featureKey === "ia.prospetti.teamsystem") {
        return !!this.impostazioniIA.use_teamsystem_new_extractor;
      }
      return !!this.impostazioniIA.use_datev_new_extractor;
    },
    async aggiornaOverrideIAAdmin(admin, featureKey, event) {
      if (!admin || this.savingImpostazioniIA) return;
      const enabled = event.target.checked;
      const previousValue = this.isIaFeatureEnabledForAdmin(admin, featureKey);
      const isOtherAdmin = !admin.is_current;
      if (isOtherAdmin) {
        event.target.checked = previousValue;
        this.openIaConfirmModal({
          type: "update",
          admin,
          featureKey,
          enabled,
          message: `Stai modificando una impostazione IA di ${admin.display_name}. Continuare?`,
        });
        return;
      }

      await this.salvaOverrideIAAdmin(admin, featureKey, enabled);
    },
    async salvaOverrideIAAdmin(admin, featureKey, enabled) {
      this.savingImpostazioniIA = true;
      this.messaggioImpostazioniIA = "";
      try {
        const res = await axios.post(
          `${API_BASE_URL}/superadmin/ia_admin_override`,
          {
            admin_user_id: admin.id,
            feature_key: featureKey,
            enabled,
          }
        );
        this.impostazioniIA.features = res.data.features || [];
        this.impostazioniIA.admins = res.data.admins || [];
      } catch (error) {
        console.error("Errore aggiornamento impostazione IA:", error);
        this.messaggioImpostazioniIA =
          "Errore nell'aggiornamento impostazione personalizzata IA";
      } finally {
        this.savingImpostazioniIA = false;
      }
    },
    async resetOverrideIAAdmin(admin, featureKey) {
      if (!admin || this.savingImpostazioniIA) return;
      const isOtherAdmin = !admin.is_current;
      if (isOtherAdmin) {
        this.openIaConfirmModal({
          type: "clear",
          admin,
          featureKey,
          message: `Stai rimuovendo l'impostazione personalizzata IA di ${admin.display_name}. Continuare?`,
        });
        return;
      }

      await this.rimuoviOverrideIAAdmin(admin, featureKey);
    },
    async rimuoviOverrideIAAdmin(admin, featureKey) {
      this.savingImpostazioniIA = true;
      this.messaggioImpostazioniIA = "";
      try {
        const res = await axios.post(
          `${API_BASE_URL}/superadmin/ia_admin_override`,
          {
            admin_user_id: admin.id,
            feature_key: featureKey,
            clear: true,
          }
        );
        this.impostazioniIA.features = res.data.features || [];
        this.impostazioniIA.admins = res.data.admins || [];
      } catch (error) {
        console.error("Errore rimozione impostazione IA:", error);
        this.messaggioImpostazioniIA =
          "Errore nella rimozione impostazione personalizzata IA";
      } finally {
        this.savingImpostazioniIA = false;
      }
    },
    openIaConfirmModal(action) {
      this.iaActionPending = action;
      this.modalTitolo = "Conferma impostazione IA";
      this.modalMessaggio = action.message;
      this.azioneDaConfermare = "azioneIAAdmin";
      this.modalVisibile = true;
    },
    // --- Metodo per caricare la lista di tutte le notizie dal backend ---
    async fetchNewsList() {
      try {
        // Chiama l'endpoint per l'admin panel che restituisce TUTTE le notizie
        const response = await axios.get(
          `${API_BASE_URL}/superadmin/get_messages`
        );
        this.newsList = response.data;
      } catch (error) {
        console.error("Errore nel recupero della lista notizie:", error);
        this.showSimpleModal = true;
        this.simpleModalMessage =
          "Errore nel caricamento della lista delle notizie.";
        this.newsList = [];
      }
    },
    getEmojiForType(type) {
      const found = this.iconOptions.find((option) => option.value === type);
      return found ? String.fromCodePoint(...found.codePoints) : "?";
    },
    getLabelForType(type) {
      const found = this.iconOptions.find((option) => option.value === type);
      return found ? found.label : "Tipo messaggio sconosciuto";
    },
    // --- Metodo chiamato quando la selezione nel dropdown cambia ---
    loadSelectedNewsCard(news) {
      console.log("DEBUG → Notizia selezionata:", news);
      console.log("DEBUG → message_type:", news.message_type);
      this.selectedNewsId = news.id;
      this.currentNews = JSON.parse(JSON.stringify(news));
      this.editingNews = true;
    },

    // --- Resetta il form per la creazione di una nuova notizia ---
    resetNewsForm() {
      this.selectedNewsId = null; // Nessuna notizia selezionata
      this.editingNews = false; // Siamo in modalita creazione
      this.currentNews = {
        id: null,
        title: "",
        content: "",
        is_active: true,
        message_type: "notizia",
      };
    },

    async saveNews() {
      if (!this.currentNews.title || !this.currentNews.content) {
        this.showSimpleModal = true;
        this.simpleModalMessage =
          "Titolo e contenuto della notizia non possono essere vuoti.";
        return;
      }

      try {
        let response;
        const payload = {
          title: this.currentNews.title,
          content: this.currentNews.content,
          is_active: this.currentNews.is_active,
          message_type: this.currentNews.message_type || "notizia",
        };

        if (this.editingNews && this.currentNews.id) {
          response = await axios.put(
            `${API_BASE_URL}/superadmin/update_message/${this.currentNews.id}`,
            payload
          );
        } else {
          response = await axios.post(
            `${API_BASE_URL}/superadmin/create_message`,
            payload
          );
        }

        if (response.data.success) {
          this.showSimpleModal = true;
          this.simpleModalMessage = `Notizia ${
            this.editingNews ? "aggiornata" : "creata"
          } con successo!`;
          await this.fetchNewsList(); // Ricarica la lista per mostrare i cambiamenti
          this.resetNewsForm(); // Resetta il form per creare una nuova notizia
        } else {
          this.showSimpleModal = true;
          this.simpleModalMessage = `Errore nel salvataggio della notizia: ${
            response.data.message || "Sconosciuto"
          }`;
        }
      } catch (error) {
        console.error("Errore nel salvataggio:", error);
        this.showSimpleModal = true;
        this.simpleModalMessage =
          "Errore durante il salvataggio della notizia.";
      }
    },

    async confirmDelete(newsId) {
      if (
        confirm(
          "Sei sicuro di voler eliminare questa notizia? Questa azione è irreversibile."
        )
      ) {
        try {
          const response = await axios.delete(
            `${API_BASE_URL}/superadmin/delete_message/${newsId}`
          );
          if (response.data.success) {
            this.showSimpleModal = true;
            this.simpleModalMessage = "Notizia eliminata con successo!";
            await this.fetchNewsList(); // Ricarica la lista
            this.resetNewsForm(); // Resetta il form
          } else {
            this.showSimpleModal = true;
            this.simpleModalMessage = `Errore durante l'eliminazione: ${
              response.data.message || "Sconosciuto"
            }`;
          }
        } catch (error) {
          console.error("Errore durante l'eliminazione della notizia:", error);
          this.showSimpleModal = true;
          this.simpleModalMessage =
            "Errore durante l'eliminazione della notizia.";
        }
      }
    },

    // *** NUOVA FUNZIONE: per troncare il testo nelle anteprime ***
    truncateText(text, length) {
      if (text.length > length) {
        return text.substring(0, length) + "...";
      }
      return text;
    },
    async caricaPrezzi() {
      if (!this.isAdminMyStudio) return;
      console.log("CARICA PREZZI");
      try {
        const res = await axios.get(`${API_BASE_URL}/getPrezziConversione`);
        this.prezzi = {
          coin_per_f24: res.data.crediti_per_f24,
          coin_per_prospetto: res.data.crediti_per_prospetto_paghe,
          coin_per_bilancio: res.data.crediti_per_bilancio,
          prezzo_per_credito: res.data.prezzo_per_credito,
          prezzo_pacchetto_10: res.data.prezzo_pacchetto_10,
          prezzo_pacchetto_50: res.data.prezzo_pacchetto_50,
          prezzo_pacchetto_100: res.data.prezzo_pacchetto_100,
          prezzo_piano_plus: res.data.prezzo_piano_plus, // Added
          prezzo_piano_premium: res.data.prezzo_piano_premium, // Added
        };
      } catch (err) {
        console.error(err);
        this.messaggioPrezzi = "Errore nel caricamento dei prezzi";
      }
    },
    async salvaPrezzi() {
      if (!this.isAdminMyStudio) return;
      if (
        this.prezzi.prezzo_piano_plus < 0 ||
        this.prezzi.prezzo_piano_premium < 0
      ) {
        this.messaggioPrezzi = "I prezzi dei piani non possono essere negativi";
        return;
      }
      try {
        const res = await axios.post(
          `${API_BASE_URL}/superadmin/update_prezzi`,
          {
            coin_to_euro: this.prezzi.prezzo_per_credito,
            coin_per_f24: this.prezzi.coin_per_f24,
            coin_per_prospetto: this.prezzi.coin_per_prospetto,
            coin_per_bilancio: this.prezzi.coin_per_bilancio,
            prezzo_pacchetto_10: this.prezzi.prezzo_pacchetto_10,
            prezzo_pacchetto_50: this.prezzi.prezzo_pacchetto_50,
            prezzo_pacchetto_100: this.prezzi.prezzo_pacchetto_100,
            prezzo_piano_plus: this.prezzi.prezzo_piano_plus,
            prezzo_piano_premium: this.prezzi.prezzo_piano_premium,
          }
        );
        this.successModalMessaggio = res.data.message;
        this.successModalVisibile = true;
        this.modificaPrezzi = false;
      } catch (err) {
        console.error(err);
        this.messaggioPrezzi = "Errore nel salvataggio";
      }
    },
    formatDate(isoString) {
      if (!isoString) return "N/D";
      const date = new Date(isoString);
      return date.toLocaleDateString("it-IT", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    annullaModifica() {
      this.modificaPrezzi = false;
      this.messaggioPrezzi = "";
      this.caricaPrezzi();
    },
    async scaricaExcelStudiMyStudio() {
      if (!this.isAdminMyStudio) return;

      if (!this.studi || this.studi.length === 0) {
        alert("Nessuno studio disponibile da esportare.");
        return;
      }

      const datiExcel = this.studi.map((studio) => ({
        "Nome Studio": studio.nome,
        "Piano Abbonamento": this.formatPiano(
          studio.piano_attuale || studio.piano
        ),
        "Crediti Disponibili": studio.crediti_disponibili,
        "Crediti Totali Acquistati": studio.crediti_totali_acquistati,
        "Euro Spesi (€)": parseFloat(studio.euro_spesi).toFixed(2),
        "Conversioni effettuate": this.totaleConversioniStudio(studio),
        "Prospetti Paghe convertiti": studio.conversioni_effettuate_prospetti,
        "Modelli F24 convertiti": studio.conversioni_effettuate_f24,
        "Bilanci Analitici convertiti": studio.conversioni_effettuate_bilanci,
      }));

      try {
        const response = await axios.post(
          `${API_BASE_URL}/superadmin/export_studi_excel`,
          { dati: datiExcel },
          { responseType: "blob" }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = `Studi MyStudio.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Errore nel download del file", error);
        alert("Errore nel download del file");
      }
    },

    userInvitationStatusLabel(utente) {
      if (utente.auth_provider === "pending_clerk") {
        return "Invito in sospeso";
      }
      if (utente.auth_provider === "internal_test") {
        return "Utente test";
      }
      if (utente.auth_provider === "clerk") {
        return "Attivo";
      }
      if (utente.auth_provider === "legacy") {
        return "Legacy";
      }
      return "Da verificare";
    },

    userInvitationStatusClass(utente) {
      if (utente.auth_provider === "pending_clerk") {
        return "pending";
      }
      if (utente.auth_provider === "internal_test") {
        return "test";
      }
      if (utente.auth_provider === "clerk") {
        return "active";
      }
      if (utente.auth_provider === "legacy") {
        return "legacy";
      }
      return "unknown";
    },

    getStudioForUser(utente) {
      return (
        this.studi.find((studio) => studio.id === utente.studio_id) ||
        this.studi.find((studio) => studio.nome === utente.studio_name) ||
        null
      );
    },

    userFullName(utente) {
      return (
        [utente?.first_name, utente?.last_name]
          .filter(Boolean)
          .join(" ")
          .trim() || "—"
      );
    },

    toggleConversionDetails(key, event) {
      const wasOpen = this.activeConversionDetails === key;
      this.closeTablePanels();
      if (!wasOpen) {
        this.conversionPopoverStyle = floatingTablePanelStyle(
          event.currentTarget,
          { width: 208, height: 155 }
        );
        this.activeConversionDetails = key;
      }
    },

    toggleUserActionsMenu(utente, event) {
      const wasOpen = this.activeUserActionsMenu === utente.email;
      this.closeTablePanels();
      if (wasOpen) return;
      this.userActionsMenuStyle = floatingTablePanelStyle(event.currentTarget, {
        width: 192,
        height: 210,
        placement: "below",
        align: "right",
      });
      this.activeUserActionsMenu = utente.email;
    },

    closeUserActionsMenu() {
      this.activeUserActionsMenu = null;
    },

    closeTablePanels() {
      this.closeUserActionsMenu();
      this.activeConversionDetails = null;
    },

    handleUserActionsOutsideClick(event) {
      if (
        event.target?.closest?.(".user-actions-dropdown, .conversioni-popover")
      )
        return;
      this.closeTablePanels();
    },

    apriDettagliUtente(utente) {
      this.dettagliUtente = utente;
      this.dettagliUtenteModalVisibile = true;
      this.closeUserActionsMenu();
    },

    chiudiDettagliUtente() {
      this.dettagliUtenteModalVisibile = false;
      this.dettagliUtente = null;
    },

    canResetTestUserPassword(utente) {
      const studio = this.getStudioForUser(utente);
      return (
        studio?.is_test_studio === true &&
        ["internal_test", "legacy"].includes(utente.auth_provider) &&
        utente.ruolo_originale !== "adminMyStudio"
      );
    },

    canConvertUserToTest(utente) {
      const studio = this.getStudioForUser(utente);
      return (
        studio?.is_test_studio === true &&
        utente.auth_provider === "clerk" &&
        utente.ruolo_originale !== "adminMyStudio"
      );
    },

    apriResetPasswordTest(utente) {
      this.resetTestUtente = utente;
      this.resetTestPassword = "";
      this.resetTestConfirmPassword = "";
      this.resetTestError = "";
      this.resetTestModalVisibile = true;
      this.closeUserActionsMenu();
    },

    chiudiResetPasswordTest() {
      if (this.resetTestLoading) return;
      this.resetTestModalVisibile = false;
      this.resetTestUtente = null;
      this.resetTestPassword = "";
      this.resetTestConfirmPassword = "";
      this.resetTestError = "";
    },

    async resetPasswordUtenteTest() {
      if (!this.resetTestUtente) return;

      if (!this.resetTestPassword || !this.resetTestConfirmPassword) {
        this.resetTestError = "Inserisci e conferma la nuova password.";
        return;
      }

      if (this.resetTestPassword.length < 8) {
        this.resetTestError = "La password deve avere almeno 8 caratteri.";
        return;
      }

      if (this.resetTestPassword !== this.resetTestConfirmPassword) {
        this.resetTestError = "Le password non coincidono.";
        return;
      }

      this.resetTestLoading = true;
      this.resetTestError = "";

      try {
        await axios.post(
          `${API_BASE_URL}/admin/reset_test_user_password`,
          {
            email: this.resetTestUtente.email,
            password: this.resetTestPassword,
          },
          { withCredentials: true }
        );

        this.successModalMessaggio = `Password aggiornata per "${this.resetTestUtente.email}".`;
        this.successModalVisibile = true;
        this.resetTestLoading = false;
        this.chiudiResetPasswordTest();
        await this.fetchDataCompleta();
      } catch (error) {
        this.resetTestError =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Errore durante il reset password.";
      } finally {
        this.resetTestLoading = false;
      }
    },

    mostraInfoResetClerk(utente) {
      this.closeUserActionsMenu();
      this.successModalMessaggio = `Per ${utente.email}, usa il link "Password dimenticata?" nella pagina di login: l'utente riceverà il codice di reset via email.`;
      this.successModalVisibile = true;
    },

    apriConversioneUtenteTest(utente) {
      this.convertTestUtente = utente;
      this.convertTestPassword = "";
      this.convertTestConfirmPassword = "";
      this.convertTestError = "";
      this.convertTestModalVisibile = true;
      this.closeUserActionsMenu();
    },

    chiudiConversioneUtenteTest() {
      if (this.convertTestLoading) return;
      this.convertTestModalVisibile = false;
      this.convertTestUtente = null;
      this.convertTestPassword = "";
      this.convertTestConfirmPassword = "";
      this.convertTestError = "";
    },

    async convertiUtenteInTest() {
      if (!this.convertTestUtente) return;

      if (!this.convertTestPassword || !this.convertTestConfirmPassword) {
        this.convertTestError = "Inserisci e conferma la nuova password test.";
        return;
      }

      if (this.convertTestPassword.length < 8) {
        this.convertTestError =
          "La password test deve avere almeno 8 caratteri.";
        return;
      }

      if (this.convertTestPassword !== this.convertTestConfirmPassword) {
        this.convertTestError = "Le password non coincidono.";
        return;
      }

      this.convertTestLoading = true;
      this.convertTestError = "";

      try {
        await axios.post(
          `${API_BASE_URL}/admin/convert_user_to_test`,
          {
            email: this.convertTestUtente.email,
            password: this.convertTestPassword,
          },
          { withCredentials: true }
        );

        this.successModalMessaggio = `Utente "${this.convertTestUtente.email}" convertito in utente test.`;
        this.successModalVisibile = true;
        this.convertTestLoading = false;
        this.chiudiConversioneUtenteTest();
        await this.fetchDataCompleta();
      } catch (error) {
        this.convertTestError =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Errore durante la conversione in utente test.";
      } finally {
        this.convertTestLoading = false;
      }
    },

    async scaricaExcelUtentiMyStudio() {
      if (!this.isAdminMyStudio) return;

      if (!this.utenti || this.utenti.length === 0) {
        alert("Nessun utente disponibile da esportare.");
        return;
      }

      const datiExcel = this.utenti.map((utente) => ({
        Email: utente.email,
        "Codice Fiscale": utente.codice_fiscale || "",
        Studio: utente.studio_name,
        Ruolo: utente.ruolo,
        Stato: this.userInvitationStatusLabel(utente),
        "Data di registrazione": this.formatDate(utente.data_registrazione),
        "Conversioni effettuate": this.totaleConversioniUtente(utente),
      }));

      try {
        const response = await axios.post(
          `${API_BASE_URL}/superadmin/export_utenti_excel`,
          { dati: datiExcel },
          { responseType: "blob" }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = `Utenti MyStudio.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Errore nel download del file", error);
        alert("Errore nel download del file");
      }
    },

    async fetchDataCompleta() {
      this.isLoading = true;

      try {
        const [studiRes, utentiRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/superadmin/get_all_studi`),
          axios.get(`${API_BASE_URL}/admin/get_all_users`),
        ]);

        this.studi = studiRes.data.studi;
        this.originalStudi = JSON.parse(JSON.stringify(this.studi));

        this.utenti = utentiRes.data.users.map((utente) => ({
          ...utente,
          ruolo_originale: utente.ruolo,
        }));

        // Aggiunge il numero di utenti a ogni studio
        const utentiPerStudio = {};
        this.utenti.forEach((utente) => {
          if (!utentiPerStudio[utente.studio_id]) {
            utentiPerStudio[utente.studio_id] = 0;
          }
          utentiPerStudio[utente.studio_id]++;
        });

        this.studi.forEach((studio, index) => {
          this.$set(
            this.studi[index],
            "numero_utenti",
            utentiPerStudio[studio.id] || 0
          );
        });
      } catch (error) {
        console.error("Errore nel recupero dati:", error);
        this.studi = [];
        this.utenti = [];
      } finally {
        this.isLoading = false;
      }
    },
    mostraUtenti(studio) {
      this.studioSelezionato = studio;
      this.modalUtentiVisibile = true;
    },
    async eliminaUtente(email) {
      try {
        const response = await axios.delete(
          `${API_BASE_URL}/admin/delete_user?email=${encodeURIComponent(email)}`
        );

        if (response.data.message) {
          this.successModalMessaggio = `Utente "${email}" eliminato con successo.`;
          this.successModalVisibile = true;
          this.fetchDataCompleta();
        }
      } catch (err) {
        console.error("Errore eliminazione utente:", err);
        alert("Errore durante l'eliminazione dell'utente");
      }
    },
    async registraUtente() {
      this.erroreRegistrazione = "";
      this.confermaRegistrazione = false;
      this.messaggioRegistrazioneSuccesso = "";
      this.lastInvitationLink = "";

      const isTestUser = this.isTestUserRegistration;

      if (
        !this.newUser.firstName?.trim() ||
        !this.newUser.lastName?.trim() ||
        !this.newUser.email ||
        !this.newUser.studio_name
      ) {
        this.erroreRegistrazione = "Tutti i campi sono obbligatori.";
        setTimeout(() => {
          this.erroreRegistrazione = "";
        }, 3000);
        return;
      }

      if (isTestUser) {
        if (
          this.tipoRegistrazione !== "esistente" ||
          !this.selectedStudioForRegistration?.is_test_studio
        ) {
          this.erroreRegistrazione =
            "Gli utenti test si possono creare solo in studi esistenti marcati come test.";
          setTimeout(() => {
            this.erroreRegistrazione = "";
          }, 3000);
          return;
        }

        if (!this.newUser.password || !this.newUser.confirmPassword) {
          this.erroreRegistrazione = "Inserisci e conferma la password test.";
          setTimeout(() => {
            this.erroreRegistrazione = "";
          }, 3000);
          return;
        }

        if (this.newUser.password !== this.newUser.confirmPassword) {
          this.erroreRegistrazione = "Le password non coincidono.";
          setTimeout(() => {
            this.erroreRegistrazione = "";
          }, 3000);
          return;
        }
      }

      if (
        this.tipoRegistrazione === "nuovo" &&
        (!this.newUser.partita_iva?.trim() ||
          !this.newUser.indirizzo_sede?.trim() ||
          !this.newUser.cap?.trim() ||
          !this.newUser.citta?.trim() ||
          !this.newUser.provincia?.trim())
      ) {
        this.erroreRegistrazione =
          "Partita IVA e indirizzo completo dello studio sono obbligatori.";
        return;
      }

      try {
        const response = await axios.post(
          `${API_BASE_URL}/admin/register_user`,
          {
            email: this.newUser.email.trim(),
            password: isTestUser ? this.newUser.password : undefined,
            first_name: this.newUser.firstName.trim(),
            last_name: this.newUser.lastName.trim(),
            crediti_disponibili: this.newUser.crediti_disponibili,
            studio_name: this.newUser.studio_name,
            tipo_abbonamento: this.newUser.tipo_abbonamento || "base",
            partita_iva: this.newUser.partita_iva?.trim(),
            indirizzo_sede: this.newUser.indirizzo_sede?.trim(),
            cap: this.newUser.cap?.trim(),
            citta: this.newUser.citta?.trim(),
            provincia: this.newUser.provincia?.trim().toUpperCase(),
            tipoRegistrazione: this.tipoRegistrazione, // invio anche questo
            account_type: isTestUser ? "test" : "real",
            force_password_setup: !isTestUser,
          },
          {
            withCredentials: true,
          }
        );

        if (response.data.success) {
          this.lastInvitationLink = isTestUser
            ? ""
            : response.data.invitation_link || "";
          this.messaggioRegistrazioneSuccesso =
            response.data.message ||
            (isTestUser
              ? "Utente test creato con successo."
              : "Utente reale creato. Ora deve completare l'account tramite invito.");
          this.successModalMessaggio = this.messaggioRegistrazioneSuccesso;
          if (this.lastInvitationLink && !response.data.invitation_email_sent) {
            this.successModalMessaggio +=
              " Email automatica non configurata: copia il link invito mostrato nel form.";
            this.messaggioRegistrazioneSuccesso = this.successModalMessaggio;
          }
          this.successModalVisibile = true;
          this.confermaRegistrazione = true;
          this.fetchDataCompleta();
          this.newUser = {
            firstName: "",
            lastName: "",
            email: "",
            accountType: "real",
            password: "",
            confirmPassword: "",
            crediti_disponibili: 0,
            studio_name: "",
            tipo_abbonamento: "base",
            partita_iva: "",
            indirizzo_sede: "",
            cap: "",
            citta: "",
            provincia: "",
          };
          if (!this.lastInvitationLink) {
            this.mostraFormRegistrazione = false; // chiude il form
          }
        }
      } catch (error) {
        console.error(error);
        this.erroreRegistrazione =
          error.response?.data?.error || "Errore nella registrazione";
        setTimeout(() => {
          this.erroreRegistrazione = "";
        }, 3000);
      }
    },
    async copyInvitationLink(link) {
      if (!link) return;

      try {
        await navigator.clipboard.writeText(link);
        this.successModalMessaggio = "Link invito copiato negli appunti.";
        this.successModalVisibile = true;
      } catch (error) {
        console.error("Errore copia link invito:", error);
        this.erroreRegistrazione =
          "Non sono riuscito a copiare automaticamente il link.";
      }
    },

    async reinviaInvitoUtente(utente) {
      this.closeUserActionsMenu();
      try {
        const response = await axios.post(
          `${API_BASE_URL}/admin/resend_user_invite`,
          { email: utente.email },
          { withCredentials: true }
        );

        this.lastInvitationLink = response.data.invitation_link || "";
        this.successModalMessaggio = response.data.invitation_email_sent
          ? `Invito reinviato via email a ${utente.email}.`
          : `Invio invito non riuscito per ${utente.email}. Riprova tra poco.`;
        this.successModalVisibile = true;
        await this.fetchDataCompleta();
      } catch (error) {
        this.erroreRegistrazione =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Errore durante il reinvio dell'invito.";
      }
    },

    toggleEditStudioType(studio, forceCancel = false) {
      if (!studio || studio.nome === "MyStudio") return;

      const id = studio.id;
      if (this.editStudioTypeMode[id]) {
        if (forceCancel) {
          this.$delete(this.editStudioTypeMode, id);
          this.$delete(this.tempStudioType, id);
          return;
        }

        this.aggiornaStudioTestMode(studio, this.tempStudioType[id]);
        this.$delete(this.editStudioTypeMode, id);
      } else {
        this.$set(
          this.tempStudioType,
          id,
          studio.is_test_studio ? "test" : "real"
        );
        this.$set(this.editStudioTypeMode, id, true);
      }
    },
    async aggiornaStudioTestMode(studio, tipoStudio) {
      if (!studio || studio.nome === "MyStudio") return;

      const nextValue = tipoStudio === "test";
      const previousValue = studio.is_test_studio;

      if (nextValue === previousValue) {
        this.$delete(this.tempStudioType, studio.id);
        return;
      }

      studio.is_test_studio = nextValue;

      try {
        const response = await axios.post(
          `${API_BASE_URL}/superadmin/update_studio_test_mode`,
          {
            studio_id: studio.id,
            is_test_studio: nextValue,
          },
          { withCredentials: true }
        );

        studio.is_test_studio = !!response.data.is_test_studio;
        this.successModalMessaggio = studio.is_test_studio
          ? `Studio "${studio.nome}" marcato come studio di test.`
          : `Studio "${studio.nome}" riportato a studio reale.`;
        this.successModalVisibile = true;
      } catch (error) {
        studio.is_test_studio = previousValue;
        console.error("Errore aggiornamento studio test:", error);
        alert(
          error.response?.data?.error ||
            "Errore durante l'aggiornamento dello studio."
        );
      } finally {
        this.$delete(this.tempStudioType, studio.id);
      }
    },
    chiediConfermaAggiornaStudio(studio) {
      this.studioSelezionato = studio;
      this.modalTitolo = "Conferma aggiornamento Coin";
      this.modalMessaggio = `Sei sicuro di voler aggiornare i Coin per lo studio "${studio.nome}"?`;
      this.azioneDaConfermare = "aggiornaStudio";
      this.modalVisibile = true;
    },
    chiediConfermaEliminaStudio(studio) {
      this.studioSelezionato = studio;
      this.modalTitolo = "Conferma eliminazione studio";
      this.modalMessaggio = `Sei sicuro di voler eliminare lo studio "${studio.nome}"? Verra eliminato lo studio e tutti gli utenti ad esso registrati. Questa azione e irreversibile.`;
      this.azioneDaConfermare = "eliminaStudio";
      this.modalVisibile = true;
    },
    chiediConfermaAggiorna(utente) {
      this.utenteSelezionato = utente;
      this.modalTitolo = "Conferma aggiornamento ruolo";
      this.modalMessaggio = `Sei sicuro di voler aggiornare il ruolo per l'utente "${utente.email}"?`;
      this.azioneDaConfermare = "aggiornaUtente";
      this.modalVisibile = true;
    },

    chiediConfermaElimina(utente) {
      this.closeUserActionsMenu();
      this.utenteSelezionato = utente;
      this.modalTitolo = "Conferma eliminazione utente";
      this.modalMessaggio = `Sei sicuro di voler eliminare l'${utente.ruolo} "${utente.email}"?`;
      this.azioneDaConfermare = "eliminaUtente";
      this.modalVisibile = true;
    },
    async eliminaStudio(studio) {
      try {
        const response = await axios.delete(
          `${API_BASE_URL}/superadmin/delete_studio?studio_id=${studio.id}`
        );

        if (response.data.message) {
          this.successModalMessaggio = `Studio "${studio.nome}" eliminato con successo.`;
          this.successModalVisibile = true;
          this.fetchDataCompleta();
        }
      } catch (error) {
        console.error("Errore eliminazione studio:", error);
        alert("Errore durante l'eliminazione dello studio");
      }
    },
    confermaAzione() {
      if (this.azioneDaConfermare === "aggiornaStudio") {
        this.aggiornaCreditiStudio(this.studioSelezionato);
      } else if (this.azioneDaConfermare === "aggiornaUtente") {
        // Applica il valore temporaneo → reale
        this.utenteSelezionato.ruolo =
          this.tempRuolo[this.utenteSelezionato.email];
        this.aggiornaRuoloUtente(this.utenteSelezionato);

        // Chiudi modalita editing
        const key = this.utenteSelezionato.email;
        this.$delete(this.editRuoloMode, key);
        this.$delete(this.tempRuolo, key);
      } else if (this.azioneDaConfermare === "eliminaUtente") {
        this.eliminaUtente(this.utenteSelezionato.email);
      } else if (this.azioneDaConfermare === "eliminaStudio") {
        this.eliminaStudio(this.studioSelezionato);
      } else if (this.azioneDaConfermare === "azioneIAAdmin") {
        const action = this.iaActionPending;
        if (action && action.type === "update") {
          this.salvaOverrideIAAdmin(
            action.admin,
            action.featureKey,
            action.enabled
          );
        } else if (action && action.type === "clear") {
          this.rimuoviOverrideIAAdmin(action.admin, action.featureKey);
        }
      }

      this.modalVisibile = false;
      this.azioneDaConfermare = null;
      this.iaActionPending = null;
    },
    annullaAzione() {
      this.modalVisibile = false;
      this.azioneDaConfermare = null;
      this.iaActionPending = null;

      // Se stavamo modificando un ruolo, chiudi editing senza salvare
      if (
        this.utenteSelezionato &&
        this.editRuoloMode[this.utenteSelezionato.email]
      ) {
        const key = this.utenteSelezionato.email;
        this.$delete(this.editRuoloMode, key);
        this.$delete(this.tempRuolo, key);
      }
    },
    toggleEditCoin(studio, forceCancel = false) {
      const id = studio.id;

      if (this.editCoinMode[id]) {
        // Stiamo uscendo dalla modalita modifica

        if (forceCancel) {
          // Annulla: ripristina valore originale e chiudi
          const original = this.originalStudi.find((s) => s.id === id);
          if (original) {
            studio.crediti_disponibili = original.crediti_disponibili;
          }
          this.$delete(this.editCoinMode, id);
          return;
        }

        // Salva normalmente
        this.normalizeCrediti(studio);
        this.aggiornaCreditiStudio(studio);
        this.$delete(this.editCoinMode, id);
      } else {
        // Entra in modifica
        this.$set(this.editCoinMode, id, true);
      }
    },
    normalizeCrediti(studio) {
      let val = studio.crediti_disponibili;

      // Se è vuoto, stringa vuota o null → metti 0
      if (val === "" || val == null) {
        studio.crediti_disponibili = 0;
        return;
      }

      // Converti in numero
      val = Number(val);

      // Se non è un numero valido (NaN) → 0
      if (isNaN(val)) {
        studio.crediti_disponibili = 0;
        return;
      }

      // Forziamo intero >= 0 (se i coin non possono essere decimali o negativi)
      studio.crediti_disponibili = Math.max(0, Math.floor(val));
    },
    toggleEditRuolo(utente, forceCancel = false) {
      const key = utente.email;

      if (this.editRuoloMode[key]) {
        // Stiamo uscendo dalla modifica
        if (forceCancel) {
          // Annulla: chiudi senza salvare
          this.$delete(this.editRuoloMode, key);
          this.$delete(this.tempRuolo, key);
          return;
        }

        // ✓ cliccata → NON salvare subito, ma aprire il modal di conferma
        this.utenteSelezionato = utente; // salva l'utente selezionato
        this.modalTitolo = "Conferma aggiornamento ruolo";
        this.modalMessaggio = `Sei sicuro di voler aggiornare il ruolo per l'utente "${utente.email}"?`;
        this.azioneDaConfermare = "aggiornaUtente"; // stessa azione del vecchio pulsante
        this.modalVisibile = true;

        // NON chiudere ancora l'editing qui: lo chiuderemo dopo conferma/annulla
      } else {
        // Entra in modifica
        this.$set(this.tempRuolo, key, utente.ruolo);
        this.$set(this.editRuoloMode, key, true);
      }
    },
    async apriStoricoOperazioni(emailUtente) {
      this.isLoadingStorico = true;
      this.storicoModalUtenteEmail = emailUtente;
      this.storicoModalVisibile = true;
      this.expandedRows = [];

      try {
        const response = await axios.get(
          `${API_BASE_URL}/admin/download_logs_user`,
          {
            params: { email: emailUtente },
          }
        );

        this.storicoOperazioni = response.data.success
          ? (response.data.logs || []).map(withVisibleConvertedFiles)
          : [];
      } catch (error) {
        console.error("Errore nel recupero dello storico operazioni:", error);
        this.storicoOperazioni = [];
      } finally {
        this.isLoadingStorico = false;
      }
    },
    chiudiStoricoModal() {
      this.storicoModalVisibile = false;
      this.storicoOperazioni = [];
      this.storicoModalUtenteEmail = "";
      this.expandedRows = [];
    },
    toggleExpand(id) {
      const index = this.expandedRows.indexOf(id);
      if (index === -1) {
        this.expandedRows.push(id);
      } else {
        this.expandedRows.splice(index, 1);
      }
    },
    isExpanded(id) {
      return this.expandedRows.includes(id);
    },
    totaleConversioniStudio(studio) {
      return (
        Number(studio.conversioni_effettuate_prospetti || 0) +
        Number(studio.conversioni_effettuate_f24 || 0) +
        Number(studio.conversioni_effettuate_bilanci || 0)
      );
    },
    totaleConversioniUtente(utente) {
      return (
        Number(utente.conversioni_effettuate_prospetti || 0) +
        Number(utente.conversioni_effettuate_f24 || 0) +
        Number(utente.conversioni_effettuate_bilanci || 0)
      );
    },
    formatPiano(piano) {
      const pianoNormalizzato = (piano || "base").toLowerCase();
      const option = this.pianiAbbonamento.find(
        (item) => item.value === pianoNormalizzato
      );
      return option ? option.label : pianoNormalizzato;
    },
    pianoClass(studio) {
      return `piano-${(
        studio.piano_attuale ||
        studio.piano ||
        "base"
      ).toLowerCase()}`;
    },
    toggleEditPiano(studio, forceCancel = false) {
      const id = studio.id;

      if (this.editPianoMode[id]) {
        if (forceCancel) {
          this.$delete(this.editPianoMode, id);
          this.$delete(this.tempPiano, id);
          return;
        }

        this.aggiornaPianoStudio(studio, this.tempPiano[id]);
        this.$delete(this.editPianoMode, id);
      } else {
        this.$set(
          this.tempPiano,
          id,
          (studio.piano_attuale || studio.piano || "base").toLowerCase()
        );
        this.$set(this.editPianoMode, id, true);
      }
    },
    async aggiornaPianoStudio(studio, nuovoPiano) {
      const piano = (nuovoPiano || "").toLowerCase();
      const pianoAttuale = (
        studio.piano_attuale ||
        studio.piano ||
        "base"
      ).toLowerCase();

      if (piano === pianoAttuale) {
        this.$delete(this.tempPiano, studio.id);
        return;
      }

      if (!this.pianiAbbonamento.some((item) => item.value === piano)) {
        alert("Piano abbonamento non valido.");
        this.$delete(this.tempPiano, studio.id);
        return;
      }

      try {
        const response = await axios.post(
          `${API_BASE_URL}/superadmin/update_piano_studio`,
          {
            studio_id: studio.id,
            tipo_abbonamento: piano,
          }
        );
        const studioAggiornato = response.data.studio || {};
        studio.piano = studioAggiornato.piano || piano;
        studio.piano_attuale = studioAggiornato.piano_attuale || piano;

        const original = this.originalStudi.find((s) => s.id === studio.id);
        if (original) {
          original.piano = studio.piano;
          original.piano_attuale = studio.piano_attuale;
        }

        this.$delete(this.tempPiano, studio.id);
        this.successModalMessaggio = `Piano dello studio "${studio.nome}" aggiornato con successo!`;
        this.successModalVisibile = true;
      } catch (err) {
        console.error(err);
        alert("Errore nell'aggiornamento del piano abbonamento.");
        this.$delete(this.tempPiano, studio.id);
      }
    },
    resetModal() {
      this.modalVisibile = false;
      this.modalTitolo = "";
      this.modalMessaggio = "";
      this.azioneDaConfermare = null;
      this.utenteSelezionato = null;
    },
    isModified(studio) {
      const original = this.originalStudi.find((s) => s.id === studio.id);
      return (
        original &&
        studio.crediti_disponibili !== original.crediti_disponibili &&
        studio.crediti_disponibili !== null &&
        studio.crediti_disponibili !== ""
      );
    },
    async aggiornaCreditiStudio(studio) {
      try {
        // Se il valore e vuoto o non valido, forzalo a 0
        if (
          studio.crediti_disponibili === null ||
          studio.crediti_disponibili === ""
        ) {
          studio.crediti_disponibili = 0;
        }
        await axios.post(`${API_BASE_URL}/superadmin/update_crediti_studio`, {
          studio_id: studio.id,
          nuovi_crediti: studio.crediti_disponibili,
        });
        // Aggiorna anche la copia originale
        const original = this.originalStudi.find((s) => s.id === studio.id);
        if (original) {
          original.crediti_disponibili = studio.crediti_disponibili;
        }
        this.successModalMessaggio = `Crediti dello studio "${studio.nome}"" aggiornati con successo!`;
        this.successModalVisibile = true;
      } catch (err) {
        console.error(err);
        alert("Errore nell'aggiornamento dei Coin.");
      }
    },
    aggiornaRuoloUtente(utente) {
      axios
        .post(`${API_BASE_URL}/superadmin/update_ruolo_utente`, {
          email: utente.email,
          ruolo: utente.ruolo,
        })
        .then(() => {
          utente.ruolo_originale = utente.ruolo;
          this.successModalVisibile = true;
          this.successModalMessaggio = `Ruolo dell'utente "${utente.email}" aggiornato con successo`;
        })
        .catch((err) => console.error(err));
    },
    goToFileSystem() {
      this.$router.push("/home/file-system");
    },
    goToDiagnosticaConversioni() {
      this.$router.push("/home/diagnostica-conversioni");
    },
    setSortS(key) {
      if (this.sortKeyS === key) {
        this.sortAscS = !this.sortAscS;
      } else {
        this.sortKeyS = key;
        this.sortAscS = true;
      }
    },
    setSortU(key) {
      if (this.sortKeyU === key) {
        this.sortAscU = !this.sortAscU;
      } else {
        this.sortKeyU = key;
        this.sortAscU = true;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleUserActionsOutsideClick);
    window.addEventListener("scroll", this.closeTablePanels, true);
    window.addEventListener("resize", this.closeTablePanels);
    this.caricaPrezzi();
    this.fetchNewsList();
    this.fetchDataCompleta();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleUserActionsOutsideClick);
    window.removeEventListener("scroll", this.closeTablePanels, true);
    window.removeEventListener("resize", this.closeTablePanels);
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges) {
      const answer = window.confirm(
        "Hai delle modifiche non salvate. Uscire comunque?"
      );
      if (answer) {
        next(); // continua la navigazione
      } else {
        next(false); // blocca la navigazione
      }
    } else {
      next(); // nessuna modifica, procedi
    }
  },
};
</script>

<style scoped>
.header {
  margin-right: 1rem;
  display: flex;
  gap: 16px; /* Spazio tra gli elementi */
  padding-top: 1rem;
  align-items: baseline;
  align-content: center;
  justify-content: center;
}
.container-area-personale {
  flex: 1; /* Occupa lo spazio disponibile, spingendo il footer verso il basso */
  display: flex;
  flex-direction: column;
}
.main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.pricing-form {
  width: min(62rem, calc(100vw - 2rem));
  margin: 0 auto 3rem;
  padding: 0;
  overflow: hidden;
  border: 1px solid #dbe4ee;
  border-radius: 12px;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.14);
}
.pricing-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.35rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}
.pricing-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 12px;
  background: #1f2937;
  color: #fff;
  font-size: 1.1rem;
}
.pricing-header p {
  margin: 0 0 0.15rem;
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
}
.pricing-header h3 {
  margin: 0;
  color: #0f172a;
  font-size: 1.35rem;
  line-height: 1.2;
}
.pricing-status {
  margin-left: auto;
  padding: 0.38rem 0.75rem;
  border-radius: 999px;
  background: #e5e7eb;
  color: #374151;
  font-size: 0.78rem;
  font-weight: 800;
  white-space: nowrap;
}
.pricing-status.editing {
  background: #dbeafe;
  color: #1d4ed8;
}
.pricing-section {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #edf2f7;
}
.pricing-section-heading {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1rem;
}
.pricing-section-heading > div {
  text-align: left;
}
.pricing-section-heading > i {
  width: 2.15rem;
  height: 2.15rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eff6ff;
  color: #2563eb;
}
.pricing-section-heading h4 {
  margin: 0 0 0.15rem;
  color: #0f172a;
  font-size: 1rem;
  text-align: left;
}
.pricing-section-heading p {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
  text-align: left;
}
.pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.9rem;
}
.package-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.plan-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.pricing-field {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-width: 0;
  padding: 0.85rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}
.pricing-field span {
  color: #334155;
  font-size: 0.86rem;
  font-weight: 800;
}
.pricing-field input {
  width: 100%;
  min-height: 2.35rem;
  padding: 0.5rem 0.65rem;
  color: #0f172a;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  font-size: 0.98rem;
  box-sizing: border-box;
}
.pricing-field input:disabled {
  color: #475569;
  background: #f1f5f9;
}
.pricing-field input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.14);
}
.pricing-field small {
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 700;
}
.pricing-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.5rem 1.35rem;
  background: #fff;
}
.pricing-feedback {
  margin: 0;
  color: #475569;
  font-size: 0.9rem;
  font-weight: 700;
}
.pricing-button-row {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-left: auto;
}
.pricing-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.45rem;
  padding: 0.6rem 1rem;
  border: none;
  border-radius: 8px;
  font-size: 0.92rem;
  font-weight: 800;
  cursor: pointer;
}
.pricing-btn.primary {
  background: #2563eb;
  color: #fff;
}
.pricing-btn.primary:hover {
  background: #1d4ed8;
}
.pricing-btn.secondary {
  background: #e5e7eb;
  color: #374151;
}
.pricing-btn.secondary:hover {
  background: #d1d5db;
}
.studio-test-hint {
  margin: -0.35rem 0 0.75rem;
  color: #64748b;
  font-size: 0.86rem;
  font-weight: 700;
  text-align: left;
}
.studio-test-hint.active {
  color: #1e3a8a;
}
.account-type-selector {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin: 0.6rem 0 0.9rem;
  text-align: left;
}
.account-type-selector label {
  color: #0f172a;
  font-size: 0.9rem;
  font-weight: 800;
}
.account-type-selector select {
  width: 100%;
  min-height: 2.65rem;
  padding: 0.55rem 0.7rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  font-size: 0.95rem;
}
.registration-info-box {
  display: flex;
  gap: 0.65rem;
  align-items: flex-start;
  margin: 0.7rem 0 1rem;
  padding: 0.8rem 0.9rem;
  border: 1px solid #cfe1d6;
  border-radius: 10px;
  background: #f4fbf6;
  color: #24543d;
  font-size: 0.9rem;
  font-weight: 700;
  text-align: left;
}
.registration-info-box i {
  margin-top: 0.12rem;
  color: #14532d;
}
.invitation-link-box {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.9rem;
  padding: 0.8rem;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #eff6ff;
  color: #1e3a8a;
  text-align: left;
}
.invitation-link-box textarea {
  min-height: 4.5rem;
  resize: vertical;
  padding: 0.6rem;
  border: 1px solid #93c5fd;
  border-radius: 8px;
  color: #0f172a;
  font-size: 0.86rem;
}
.invitation-link-box button {
  align-self: flex-start;
  padding: 0.55rem 0.9rem;
  border: none;
  border-radius: 8px;
  background: #1d4ed8;
  color: #fff;
  font-weight: 800;
  cursor: pointer;
}
.studio-type-cell {
  white-space: nowrap;
}
.studio-type-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
}
.studio-type-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-width: 6.2rem;
  padding: 0.22rem 0.55rem;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 800;
  border: 1px solid #d9e2ec;
  background: #f8fafc;
  color: #243b53;
}
.studio-type-badge.test {
  border-color: #bfdbfe;
  background: #dbeafe;
  color: #1e3a8a;
}
.studio-type-select {
  min-width: 6.2rem;
  height: 2rem;
  border: 1px solid #b8c2cc;
  border-radius: 6px;
  background: #ffffff;
  color: #243b53;
  font-weight: 600;
  padding: 0 0.45rem;
}
@media (max-width: 780px) {
  .pricing-header {
    align-items: flex-start;
  }
  .pricing-status {
    margin-left: 0;
  }
  .pricing-grid,
  .package-grid,
  .plan-grid {
    grid-template-columns: 1fr;
  }
  .pricing-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .pricing-button-row {
    width: 100%;
    margin-left: 0;
  }
  .pricing-btn {
    flex: 1;
  }
}
.user-registration-form input,
.user-registration-form select {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0.8rem 1rem;
  font-size: 0.98rem;
  color: #0f172a;
  background: #fff;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.user-registration-form input:focus,
.user-registration-form select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.user-registration-form select {
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #64748b 50%),
    linear-gradient(135deg, #64748b 50%, transparent 50%);
  background-position: calc(100% - 1.1rem) 50%, calc(100% - 0.8rem) 50%;
  background-size: 0.32rem 0.32rem, 0.32rem 0.32rem;
  background-repeat: no-repeat;
  cursor: pointer;
}

.user-registration-form {
  width: min(40rem, calc(100vw - 2rem));
  margin: 0 auto 3rem;
  padding: 1.75rem 2rem 2rem;
  border: 1px solid #dbe4ee;
  border-radius: 16px;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
}

.user-registration-form button {
  font: inherit;
  cursor: pointer;
}

button.toggle-form-btn {
  width: 10.5rem;
  padding: 0.6rem 1rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease,
    box-shadow 0.3s ease;
  border: none;
  color: #333;
  background-color: transparent;
}

button.toggle-form-btn:hover:not(.active) {
  background-color: #e4e4e4;
}

button.toggle-form-btn.active {
  background-color: #cacaca;
}
.controlli-wrapper {
  display: flex;
  gap: 4px;
  justify-content: center;
  margin-bottom: 2rem;
  display: flex;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 0.4rem 1.2rem 0.4rem 1.2rem;
  border-radius: 20px;
}
.password-container {
  position: relative;
}

.password-container input {
  position: relative;
  padding-right: 2.9rem;
}

.toggle-password-icon {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  cursor: pointer;
  color: #94a3b8;
  font-size: 1rem;
  transition: color 0.3s ease;
}

.password-container input:focus + .toggle-password-icon,
.toggle-password-icon:hover {
  color: #475569;
}
.toggle-buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin: 0 auto 1.25rem auto;
  width: 100%;
  padding: 0.35rem;
  background: #eef2f7;
  border-radius: 12px;
}

.btn-salva,
.btn-annulla {
  padding: 0.5rem 1.2rem;
  font-size: 0.95rem;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.btn-salva {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

.btn-salva:hover {
  background-color: #0069d9;
  border-color: #0062cc;
}

.toggle-buttons button {
  flex: 1;
  background-color: transparent;
  color: #475569;
  border: none;
  padding: 0.7rem 0.9rem;
  font-size: 0.94rem;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.toggle-buttons button.active {
  background-color: #2563eb;
  color: white;
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.18);
}

.toggle-buttons button:not(.active):hover {
  background-color: #dbe4ee;
}

.toggle-buttons button:not(.active):hover {
  background-color: #b2b2b2; /* Un grigio leggermente più scuro */
}

.table-wrapper {
  display: flex;
  gap: 0.5rem; /* spazio tra pulsanti */
}
.controlli-btn {
  padding: 0.2rem;
}
.modal-content-news {
  max-width: 35rem;
  min-width: 18rem;
  max-height: 37rem;
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}
.ai-settings-overlay {
  backdrop-filter: blur(2px);
}
.ai-settings-modal {
  position: relative;
  width: min(68rem, calc(100vw - 2rem));
  max-width: none;
  max-height: calc(100vh - 3rem);
  padding: 0;
  overflow: hidden;
  text-align: left;
  border: 1px solid #dbe4ee;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.24);
  display: flex;
  flex-direction: column;
}
.ai-modal-close {
  position: absolute;
  top: 0.9rem;
  right: 0.9rem;
  width: 2.15rem;
  height: 2.15rem;
  border: none;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.ai-modal-close:hover {
  background: #e2e8f0;
  color: #0f172a;
}
.ai-settings-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 1.75rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}
.ai-header-icon,
.ai-setting-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.ai-header-icon {
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 12px;
  background: #1f2937;
  color: #fff;
  font-size: 1.15rem;
}
.ai-header-copy {
  min-width: 0;
  flex: 1;
}
.ai-header-copy p {
  margin: 0 0 0.15rem;
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}
.ai-header-copy h2 {
  margin: 0;
  color: #0f172a;
  font-size: 1.35rem;
  line-height: 1.2;
}
.ai-status-badge {
  margin-right: 2.4rem;
  padding: 0.38rem 0.7rem;
  border-radius: 999px;
  background: #e5e7eb;
  color: #374151;
  font-size: 0.78rem;
  font-weight: 800;
  white-space: nowrap;
}
.ai-status-badge.active {
  background: #dcfce7;
  color: #166534;
}
.ai-settings-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;
  min-height: 10rem;
  color: #475569;
  font-weight: 700;
}
.ai-settings-body {
  overflow-y: auto;
  padding: 1.5rem 0 1rem;
}
.ai-loader {
  width: 1rem;
  height: 1rem;
  border: 2px solid #cbd5e1;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: ai-spin 0.8s linear infinite;
}
@keyframes ai-spin {
  to {
    transform: rotate(360deg);
  }
}
.ai-setting-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  margin: 0 1.75rem 1rem;
  padding: 1.15rem;
  border: 1px solid #dbe4ee;
  border-radius: 8px;
  background: #fff;
}
.ai-setting-card.enabled {
  border-color: #86efac;
  background: #f7fef9;
}
.ai-setting-main {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  min-width: 0;
}
.ai-setting-icon {
  width: 2.3rem;
  height: 2.3rem;
  border-radius: 10px;
  background: #eff6ff;
  color: #2563eb;
}
.ai-setting-card.enabled .ai-setting-icon {
  background: #dcfce7;
  color: #15803d;
}
.test-tools-modal {
  max-width: 46rem;
}
.test-tools-body {
  padding-top: 1.25rem;
}
.test-tools-header-icon {
  background: #fff2cc;
  color: #8a5a08;
}
.test-tools-setting-icon img {
  width: 2rem;
  height: 2rem;
  object-fit: contain;
}
.ai-setting-main h3 {
  margin: 0 0 0.2rem;
  color: #0f172a;
  font-size: 1rem;
}
.ai-setting-main p {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
}
.ai-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.ai-switch input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.ai-switch-track {
  position: relative;
  display: inline-flex;
  width: 3.25rem;
  height: 1.85rem;
  border-radius: 999px;
  background: #cbd5e1;
  transition: background-color 0.2s ease;
}
.ai-switch-thumb {
  position: absolute;
  top: 0.22rem;
  left: 0.24rem;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.22);
  transition: transform 0.2s ease;
}
.ai-switch input:checked + .ai-switch-track {
  background: #22c55e;
}
.ai-switch input:checked + .ai-switch-track .ai-switch-thumb {
  transform: translateX(1.34rem);
}
.ai-switch input:focus-visible + .ai-switch-track {
  outline: 3px solid rgba(37, 99, 235, 0.2);
  outline-offset: 3px;
}
.ai-switch input:disabled + .ai-switch-track {
  cursor: wait;
  opacity: 0.65;
}
.ai-admin-overrides {
  margin: 0 1.75rem 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}
.ai-admin-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}
.ai-admin-heading h3 {
  margin: 0 0 0.25rem;
  color: #0f172a;
  font-size: 1rem;
}
.ai-admin-heading p {
  margin: 0;
  color: #64748b;
  font-size: 0.88rem;
}
.ai-empty-state {
  padding: 1rem;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  font-weight: 700;
}
.ai-admin-table-wrapper {
  overflow-x: auto;
}
.ai-admin-table {
  width: 100%;
  min-width: 46rem;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}
.ai-admin-table th,
.ai-admin-table td {
  padding: 0.85rem;
  border-bottom: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  vertical-align: middle;
}
.ai-admin-table th:last-child,
.ai-admin-table td:last-child {
  border-right: none;
}
.ai-admin-table tr:last-child td {
  border-bottom: none;
}
.ai-admin-table th {
  background: #f8fafc;
  color: #334155;
  font-size: 0.78rem;
  text-align: left;
  text-transform: uppercase;
}
.ai-admin-table tr.current td {
  background: #f7fef9;
}
.ai-admin-user {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 11rem;
}
.ai-admin-user strong {
  color: #0f172a;
  font-size: 0.92rem;
}
.ai-admin-user span {
  color: #64748b;
  font-size: 0.78rem;
}
.ai-admin-user em {
  width: fit-content;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  font-size: 0.68rem;
  font-style: normal;
  font-weight: 800;
  text-transform: uppercase;
}
.ai-override-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
}
.ai-switch-small .ai-switch-track {
  width: 2.65rem;
  height: 1.5rem;
}
.ai-switch-small .ai-switch-thumb {
  top: 0.18rem;
  left: 0.2rem;
  width: 1.14rem;
  height: 1.14rem;
}
.ai-switch-small input:checked + .ai-switch-track .ai-switch-thumb {
  transform: translateX(1.1rem);
}
.ai-override-source {
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
}
.ai-override-source.override {
  color: #1d4ed8;
}
.ai-reset-override {
  border: none;
  background: transparent;
  color: #2563eb;
  cursor: pointer;
  font-size: 0.76rem;
  font-weight: 800;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 0.15rem;
}
.ai-reset-override:hover {
  color: #1d4ed8;
}
.settings-feedback {
  margin: 0 1.75rem 1rem;
  color: #475569;
  font-size: 0.9rem;
  font-weight: 700;
}
.modal-actions {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1rem;
}
.modal-actions button {
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 0.55rem 1.1rem;
}
.ai-settings-actions {
  justify-content: flex-end;
  margin: 0;
  padding: 1rem 1.75rem 1.5rem;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  flex: 0 0 auto;
  box-shadow: 0 -10px 24px rgba(15, 23, 42, 0.06);
}
.ai-settings-actions button {
  min-width: 8.5rem;
  border-radius: 8px;
  font-weight: 700;
}
.ai-settings-actions button:disabled {
  cursor: wait;
  opacity: 0.7;
}
@media (max-width: 560px) {
  .ai-settings-header,
  .ai-setting-card,
  .ai-settings-actions {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .ai-settings-header {
    align-items: flex-start;
  }
  .ai-status-badge {
    margin-right: 2.2rem;
  }
  .ai-setting-card {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .ai-admin-overrides {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .settings-feedback {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .ai-settings-actions {
    flex-direction: column-reverse;
  }
  .ai-settings-actions button {
    width: 100%;
  }
}
.btn {
  padding: 0.5rem 1rem;
  margin: 0 0.3rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-confirm {
  background-color: #007bff;
  color: white;
}
.btn-cancel {
  background-color: #ccc;
  color: #333;
}
.btnannulla {
  background-color: #ccc !important;
  color: #333 !important;
}
.table-container {
  min-width: 75rem; /* o la larghezza che preferisci */
  margin: 0 auto; /* per centrare il contenitore */
}
.table-container2 {
  padding-top: 4rem;
  margin: 0 auto; /* per centrare il contenitore */
}
.table-container2 td:nth-child(4),
.table-container2 th:nth-child(4),
.table-container2 td:nth-child(5),
.table-container2 th:nth-child(5),
.table-container2 td:nth-child(6),
.table-container2 th:nth-child(6) {
  width: 8rem;
}
.usertable {
  width: 100%; /* Occupa tutto lo spazio del contenitore */
  border-collapse: collapse;
  min-width: 78rem;
  max-width: 82rem;
}
.studiotable {
  border-collapse: collapse;
  min-width: 70rem;
  max-width: 82rem;
}
.usertable th,
.studiotable th {
  text-align: center;
}
.studiotable td:nth-child(1),
.studiotable th:nth-child(1) {
  min-width: 9rem;
}
.studiotable td:nth-child(2),
.studiotable th:nth-child(2) {
  min-width: 8rem;
}
.studiotable td:nth-child(3),
.studiotable th:nth-child(3) {
  width: 7rem;
  min-width: 7rem;
}
.studiotable td:nth-child(4),
.studiotable th:nth-child(4) {
  width: 6.8rem;
  min-width: 6.8rem;
}
.studiotable td:nth-child(5),
.studiotable th:nth-child(5) {
  width: 5.8rem;
}
.studiotable td:nth-child(6),
.studiotable th:nth-child(6) {
  width: 7.4rem;
}
.studiotable td:nth-child(7),
.studiotable th:nth-child(7) {
  width: 7rem;
}
.studiotable td:nth-child(8),
.studiotable th:nth-child(8) {
  width: 5.6rem;
}
.studiotable td:nth-child(9),
.studiotable th:nth-child(9) {
  width: 4.6rem;
}
.piano-cell {
  white-space: nowrap;
}
.piano-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
}
.piano-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 4.9rem;
  padding: 0.22rem 0.55rem;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 700;
  border: 1px solid #d9e2ec;
  background: #f8fafc;
  color: #243b53;
}
.piano-badge.piano-plus {
  border-color: #b8d7f3;
  background: #e8f3fc;
  color: #155f92;
}
.piano-badge.piano-premium {
  border-color: #d6c47b;
  background: #fff6cc;
  color: #795400;
}
.piano-select {
  min-width: 5.8rem;
  height: 2rem;
  border: 1px solid #b8c2cc;
  border-radius: 6px;
  background: #ffffff;
  color: #243b53;
  font-weight: 600;
  padding: 0 0.45rem;
}
.conversioni-cell {
  position: relative;
  display: inline-flex;
  justify-content: center;
  width: 100%;
}
.conversioni-total {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  min-width: 3rem;
  padding: 0.2rem 0.5rem;
  border: 1px solid #c9d8e6;
  border-radius: 999px;
  background: #f8fafc;
  color: #102a43;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}
.conversioni-total:hover,
.conversioni-total:focus {
  border-color: #b8d7f3;
  background: #e8f3fc;
  outline: none;
}
.conversioni-popover {
  position: fixed;
  z-index: 1000;
  min-width: 12.5rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid #d9e2ec;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(16, 42, 67, 0.18);
  color: #102a43;
  text-align: left;
}
.conversioni-popover strong {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.9rem;
}
.conversioni-popover span {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.12rem 0;
  white-space: nowrap;
}
.download-btn {
  display: block;
  margin-left: auto;
  background-color: #2874a6; /* blu scuro */
  color: white; /* testo bianco */
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}
.download-btn:hover {
  background-color: #1b4f72; /* blu ancora più scuro */
}
.modal-overlayform {
  position: fixed; /* gia corretto */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* aumenta per sicurezza */
  pointer-events: all;
}
.flexing {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content-storico {
  position: relative;
  max-height: 80vh;
  padding: 2rem;
  overflow-y: auto;
  border-radius: 8px;
  background: #ffffff;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.storico-btn {
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #2874a6;
  cursor: pointer;
  font-size: 1.1rem;
  padding: 0.35rem 0.5rem;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.storico-btn:hover {
  background-color: #e0f0ff;
  color: #007bff;
}

.download-log-table {
  width: 65rem;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.download-log-table thead {
  background-color: #f0f0f0;
}

.download-log-table th {
  text-align: center !important;
}

.download-log-table th,
.download-log-table td {
  padding: 0.75rem;
  border: 1px solid #ddd;
  text-align: left;
  overflow-wrap: break-word;
}

.download-log-table th:nth-child(1),
.download-log-table td:nth-child(1) {
  width: 25%;
}

.download-log-table th:nth-child(2),
.download-log-table td:nth-child(2) {
  width: 25%;
}

.download-log-table th:nth-child(3),
.download-log-table td:nth-child(3) {
  width: 34%;
}

.download-log-table th:nth-child(4),
.download-log-table td:nth-child(4) {
  width: 16%;
  text-align: center;
}

.expanded-row {
  padding-top: 1em !important;
}

.operationtext {
  height: 2rem;
  color: #666;
  font-style: italic;
  text-align: center !important;
}

.chip {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  background-color: #eef1f5;
  color: #333;
  transition: background-color 0.2s ease;
}

.chip:hover {
  background-color: #dbe5f0;
}

.clickable-cell {
  color: #0056b3;
  cursor: pointer;
}

.loader-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.loader {
  width: 24px;
  height: 24px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.filescaricatititle {
  font-weight: 700;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.link-button {
  background: none;
  border: none;
  color: #2874a6;
  text-decoration: underline;
  cursor: pointer;
}
.crediti-wrapper {
  height: 44px; /* stessa altezza di un input */
  margin: 0.5rem 0;
}

.hiddenInput {
  opacity: 0;
  height: 0;
  pointer-events: none;
}
.formtitle {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin: 0;
  padding-bottom: 0;
  font-size: 1.3rem;
  color: #1e293b;
}
.formsubtitle {
  margin: 0.4rem 0 0;
  color: #64748b;
  font-size: 0.95rem;
  text-align: left;
}
.registration-inline-subtitle {
  margin-bottom: 1.25rem;
}
.user-registration-form > div:not(.registration-actions) {
  margin-bottom: 1rem;
}
.row-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}
.studio-registration-fields {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0.8rem;
}
.studio-registration-fields > input:first-child,
.studio-registration-fields > input:nth-child(2) {
  grid-column: span 3;
}
.studio-registration-wide {
  grid-column: span 6;
}
.studio-registration-fields > input:nth-child(4) {
  grid-column: span 1;
}
.studio-registration-fields > input:nth-child(5) {
  grid-column: span 3;
}
.studio-registration-fields > input:nth-child(6) {
  grid-column: span 2;
}
.studio-registration-province {
  text-transform: uppercase;
}
@media (max-width: 700px) {
  .studio-registration-fields {
    grid-template-columns: 1fr;
  }
  .studio-registration-fields > input:first-child,
  .studio-registration-fields > input:nth-child(2),
  .studio-registration-wide,
  .studio-registration-fields > input:nth-child(4),
  .studio-registration-fields > input:nth-child(5),
  .studio-registration-fields > input:nth-child(6) {
    grid-column: auto;
  }
}
.registration-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-top: 1.75rem;
}
.registration-btn {
  min-height: 2.75rem;
  padding: 0.75rem 1.35rem;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease,
    box-shadow 0.2s ease;
}
.registration-btn.cancel {
  background: #e5e7eb;
  color: #374151;
}
.registration-btn.cancel:hover {
  background: #d1d5db;
}
.registration-btn.primary {
  background: #2563eb;
  color: #fff;
  min-width: 12.5rem;
}
.registration-btn.primary:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.22);
}
.registration-feedback {
  margin: 1.25rem 0 0;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  text-align: left;
  font-size: 0.95rem;
}
.registration-feedback.error {
  background: #fee2e2;
  color: #b91c1c;
  border-left: 4px solid #ef4444;
}
.registration-feedback.success {
  background: #ecfdf3;
  color: #166534;
  border-left: 4px solid #22c55e;
}
.required {
  color: #ef4444;
}
label {
  font-weight: 400 !important;
}
.modal-content-news ul {
  max-height: 27rem;
  overflow-y: auto;
  text-align: left;
  padding: 0.5rem 0rem 1rem 2rem;
}
.modal-content-news li {
  padding: 0.3rem;
}
input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
  -webkit-appearance: none; /* Chrome, Safari, Opera */
  appearance: none; /* Standard CSS */
}

/* In Chrome, Safari, Opera nasconde le freccette specifiche */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
.news-selector {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.news-selector label {
  font-weight: bold;
  color: #555;
  white-space: nowrap; /* Evita che il testo vada a capo */
}

.news-selector .select-style {
  /* Aggiunto classe per styling più specifico */
  flex-grow: 1; /* Permette alla select di espandersi */
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  background-color: white;
  cursor: pointer;
  appearance: none; /* Rimuove lo stile di default del sistema operativo */
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%236c757d' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"); /* Freccia personalizzata */
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
}

.news-selector .select-style:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-delete-small {
  padding: 6px 12px;
  background-color: #dc3545; /* Rosso per eliminare */
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85em;
  transition: background-color 0.2s ease;
  white-space: nowrap; /* Evita che il testo vada a capo */
}

.separator-line {
  /* Ho rinominato la classe per evitare conflitti */
  border: 0;
  height: 1px;
  background-color: #ddd;
  margin: 20px 0;
}
/* Stili per il modale ingrandito */
.modal-content-news.large-modal-content-news {
  max-width: 90vw; /* Più largo */
  width: 90%;
  max-height: 90vh; /* Più alto */
  height: auto; /* Per adattarsi al contenuto */
  overflow-y: auto; /* Scroll se il contenuto è troppo lungo */
  padding: 25px;
}

/* Layout a due colonne per la gestione notizie */
.news-manager-layout {
  display: flex;
  gap: 20px; /* Spazio tra le colonne */
  flex-wrap: wrap; /* Permette il wrap su schermi piccoli */
}

/* Pannello lista notizie (sinistra) */
.news-list-panel {
  flex: 1; /* Prende spazio disponibile */
  min-width: 300px; /* Larghezza minima */
  border-right: 1px solid #eee; /* Separatore visivo */
  padding-right: 20px;
  padding-left: 5px;
  max-height: 70vh; /* Altezza massima per lo scroll */
  overflow-y: auto; /* Scroll per la lista */
}

.news-list-panel h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
}

.btn-create-new {
  background-color: #828282; /* Verde: il colore predefinito del pulsante */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease-in-out; /* Rende le transizioni fluide */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
/* Pseudo-classe per l'hover: quando il mouse è sopra il pulsante */
.btn-create-new:hover {
  background-color: #5c5c5c; /* Verde più scuro all'hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px); /* Piccolo sollevamento visivo */
}

/* Pseudo-classe per l'active: quando il pulsante viene cliccato/premuto */
.btn-create-new:active {
  background-color: #1e7e34; /* Verde ancora più scuro quando attivo */
  transform: translateY(0); /* Ritorna alla posizione normale */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Pseudo-classe per il focus: quando il pulsante è selezionato via tastiera (es. con il tasto Tab) */
.btn-create-new:focus {
  outline: 2px solid #0056b3; /* Contorno per indicare il focus */
  outline-offset: 2px;
}
.btn-create-new.selected-action-btn {
  background-color: #007bff; /* Blu: colore per lo stato "selezionato" */
  color: white;
  border: 1px solid #0056b3;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25); /* Un leggero "glow" */
}

/* Stile per l'hover quando il pulsante e gia nello stato "selezionato" */
.btn-create-new.selected-action-btn:hover {
  background-color: #0056b3; /* Blu leggermente più scuro all'hover */
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.4);
}

/* Stile per l'active quando il pulsante e gia nello stato "selezionato" */
.btn-create-new.selected-action-btn:active {
  background-color: #004085; /* Blu ancora più scuro quando cliccato */
}

.no-news-message {
  color: #666;
  font-style: italic;
  padding: 10px;
  border: 1px dashed #ccc;
  border-radius: 5px;
  text-align: center;
  margin-top: 20px;
}

/* Contenitore per le card delle notizie */
.news-cards-container {
  display: flex;
  flex-direction: column; /* Impila le card verticalmente */
  gap: 10px; /* Spazio tra le card */
}

/* Stile per ogni riquadro notizia */
.news-card {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.news-card:hover {
  background-color: #e9e9e9;
  border-color: #ccc;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.news-card.selected-news {
  border-color: #007bff; /* Bordo blu per la notizia selezionata */
  background-color: #eaf5ff; /* Sfondo leggermente blu */
  box-shadow: 0 0 0 2px #007bff; /* Contorno più evidente */
}

.news-card .card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.news-card .card-header h4 {
  flex: 1;
  margin: 0;
  color: #333;
  font-size: 1.1em;
}

.news-status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: bold;
}
.status-active {
  background-color: #d4edda;
  color: #155724;
}
.status-inactive {
  background-color: #f8d7da;
  color: #721c24;
}

.news-card .card-preview {
  font-size: 0.9em;
  color: #666;
  margin-bottom: 10px;
  line-height: 1.4;
}

.news-card .card-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end; /* Allinea i pulsanti a destra */
}

.btn-edit-small,
.btn-delete-small {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85em;
  transition: background-color 0.2s;
}

.btn-edit-small {
  background-color: #007bff;
  color: white;
}
.btn-edit-small:hover {
  background-color: #0056b3;
}

.btn-delete-small {
  background-color: #dc3545;
  color: white;
}
.btn-delete-small:hover {
  background-color: #c82333;
}

/* Pannello di modifica notizia (destra) */
.news-edit-panel {
  flex: 2; /* Prende più spazio */
  min-width: 400px; /* Larghezza minima */
  padding-left: 20px;
}

.news-edit-panel h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
}

.news-title-input {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
}

.textarea-messaggio {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  resize: vertical; /* Permette solo il ridimensionamento verticale */
}

.active-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 30px;
  margin-bottom: 20px;
  font-size: 1em;
  color: #555;
}

.active-checkbox input[type="checkbox"] {
  margin-right: 5px;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.btn-salva {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
}
.btn-salva:hover {
  background-color: #0056b3;
}

.btn-annulla {
  background-color: #6c757d;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
}
.btn-annulla:hover {
  background-color: #5a6268;
}

/* Media Queries per schermi più piccoli */
@media (max-width: 768px) {
  .news-manager-layout {
    flex-direction: column; /* Impila le colonne su schermi piccoli */
  }

  .news-list-panel {
    border-right: none;
    border-bottom: 1px solid #eee; /* Separatore in basso */
    padding-right: 0;
    padding-bottom: 20px;
    max-height: 40vh; /* Riduci altezza della lista */
  }

  .news-edit-panel {
    padding-left: 0;
    padding-top: 20px;
  }
}
.utentiregistrati {
  font-size: 1.075rem;
  margin-top: -0.5rem;
  color: #2874a6;
}
input.modified {
  border: 2px solid #0dad23;
  background-color: #cee9cb;
  transition: all 0.3s ease;
}
.input-modificato {
  border: 1px solid #0dad23;
  background-color: #cee9cb;
  transition: all 0.3s ease;
}
.skeleton-row {
  background: linear-gradient(90deg, #eee, #ddd, #eee);
  height: 20px;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    background-position: -100px;
  }
  100% {
    background-position: 100px;
  }
}
.tabletitle {
  margin: 0;
  font-size: 1.3rem;
}
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.table-actions {
  display: flex;
  gap: 0.5rem;
}
th {
  user-select: none;
}

th:hover {
  background-color: #ededed;
}
icon-selector {
  margin: 15px 0;
}
.messagetypetitle {
  text-align: left;
}
.icon-options {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.icon-option {
  cursor: pointer;
  padding: 6px 10px;
  border: 1px solid transparent;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 10px;
  transition: border-color 0.3s, background-color 0.3s;
}

.icon-option.selected {
  border-color: #007bff;
  background-color: #cce5ff !important;
}

.message-type-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.8rem;
  flex: 0 0 auto;
  line-height: 1;
}

.emoji {
  font-size: 24px;
}

.label {
  margin-top: 5px;
  font-size: 14px;
  text-align: center;
}
.prezziformtitle {
  font-size: 1.1rem;
}
.coin-cell {
  position: relative;
  padding: 8px 4px 8px 8px;
}

.coin-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 4px;
}

.coin-value-wrapper {
  flex: 1;
  min-width: 0;
}

.coin-input,
.coin-display {
  width: 100%;
  text-align: right;
  padding: 4px 6px;
  box-sizing: border-box;
}

.coin-input {
  border: 1px solid #a0c4ff;
  border-radius: 4px;
  background: #f0f8ff;
}

.coin-input:focus {
  border-color: #2196f3;
  outline: none;
}

.toggle-edit-btn {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #f5f5f5;
  cursor: pointer;
}

.toggle-edit-btn:hover {
  background: #e8f0fe;
  border-color: #90b4fc;
}

.toggle-edit-btn.editing {
  background: #e3f2fd;
  border-color: #2196f3;
  color: #1976d2;
}
.cancel-edit-btn {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  padding: 0;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #d32f2f;
  cursor: pointer;
}

.cancel-edit-btn:hover {
  background: #ffebee;
}
.table-wrapper.azioni-compatte {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}
.btn-azione {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px; /* quadrato piccolo */
  height: 36px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #555;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.18s ease;
  position: relative;
}

/* Effetto hover + focus */
.btn-azione:hover,
.btn-azione:focus {
  background: rgba(0, 0, 0, 0.06);
  color: #333;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

.btn-azione:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* Pulsante Elimina - rosso tenue */
.btn-elimina {
  color: #8e8887;
}

.btn-elimina:hover,
.btn-elimina:focus {
  background: rgba(231, 76, 60, 0.12);
  color: #c0392b;
}

/* Pulsante Aggiorna / Salva - verde / blu tenue */
.btn-aggiorna {
  color: #2ecc71;
}

.btn-aggiorna:hover,
.btn-aggiorna:focus {
  background: rgba(46, 204, 113, 0.12);
  color: #27ae60;
}

.btn-test-user {
  color: #8e8887;
}

.btn-test-user:hover,
.btn-test-user:focus {
  background: rgba(30, 58, 138, 0.12);
  color: #1e3a8a;
}

.convert-test-modal input {
  width: 100%;
  box-sizing: border-box;
  margin: 0.35rem 0;
  padding: 0.65rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
}

.convert-test-modal p {
  text-align: left;
}

.convert-test-error {
  margin: 0.5rem 0 0;
  color: #b91c1c;
  font-weight: 700;
}

/* Opzionale: etichetta piccola sotto (se vuoi tenere il testo) */
.btn-label {
  position: absolute;
  bottom: -18px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.68rem;
  color: #666;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;
}

.btn-azione:hover .btn-label {
  opacity: 0.9;
}
.admin-user-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 6.4rem;
  padding: 0.32rem 0.58rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
}
.admin-user-status-badge.pending {
  color: #92400e;
  background: #fef3c7;
}
.admin-user-status-badge.test {
  color: #1e3a8a;
  background: #dbeafe;
}
.admin-user-status-badge.active {
  color: #166534;
  background: #dcfce7;
}
.admin-user-status-badge.legacy {
  color: #374151;
  background: #e5e7eb;
}
.admin-user-status-badge.unknown {
  color: #7f1d1d;
  background: #fee2e2;
}
.ruolo-cell {
  position: relative;
  padding: 8px 4px;
}

.ruolo-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 6px;
}

.ruolo-value-wrapper {
  flex: 1;
  min-width: 0;
}

.ruolo-select,
.ruolo-display {
  width: 95%;
  padding: 4px 6px;
  box-sizing: border-box;
  text-align: center;
  font-size: 14px;
}

.ruolo-select {
  border: 1px solid #a0c4ff;
  border-radius: 4px;
  background: #f0f8ff;
}

.ruolo-select:focus {
  border-color: #2196f3;
  outline: none;
}

.ruolo-display {
  display: inline-block;
  color: #333;
}

/* Stile speciale per adminMyStudio (opzionale, per renderlo più evidente) */
.admin-fixed {
  font-weight: bold;
  color: #555;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
}

/* Evidenzia se modificato (opzionale) */
.ruolo-select.input-modificato {
  border: 1px solid #0dad23;
  background-color: #cee9cb;
}

.actions-menu-wrapper {
  position: relative;
  display: inline-flex;
  justify-content: center;
}

.btn-menu-utente {
  width: 2rem;
}

.user-actions-dropdown {
  position: fixed;
  z-index: 1000;
  min-width: 12rem;
  max-height: calc(100vh - 1rem);
  overflow-y: auto;
  background: #fff;
  border: 1px solid #d7e2db;
  border-radius: 12px;
  box-shadow: 0 16px 36px rgba(15, 61, 46, 0.16);
}

.user-actions-dropdown button {
  display: block;
  width: 100%;
  padding: 0.7rem 0.9rem;
  border: 0;
  background: #fff;
  color: #0b2b46;
  cursor: pointer;
  font-size: 0.92rem;
  text-align: left;
}

.user-actions-dropdown button:hover:not(:disabled) {
  background: #f1f8f4;
}

.user-actions-dropdown button.danger {
  color: #b42318;
}

.user-actions-dropdown button:disabled {
  color: #a7a7a7;
  cursor: not-allowed;
}

.user-details-modal {
  max-width: 560px;
}

.user-details-grid {
  display: grid;
  grid-template-columns: minmax(160px, 1fr) minmax(0, 1.4fr);
  gap: 0.75rem 1rem;
  margin: 1rem 0;
  text-align: left;
}

.user-details-grid span {
  color: #66756d;
  font-weight: 700;
}

.user-details-grid strong {
  min-width: 0;
  overflow-wrap: anywhere;
  color: #0b2b46;
}
</style>
